/*
 Dashboard
*/
import Dashboard from "@plannel/pages/dashboard/Dashboard";
import DpDashboard from "@plannel/pages/dashboard/DpDashboard";
import IPDashboard from "@plannel/pages/dashboard/IPDashboard";
import RpDashboard from "@plannel/pages/dashboard/RpDashboard";
/*
 * dashboard_temp/ 목업 6종은 **메뉴에서 내렸다**(2026-08-28). 화면 파일은 pages/dashboard_temp/ 에
 *   그대로 남아 있으니, DW 전환이 끝나 다시 띄울 때는 import 와 아래 SNOP 항목만 되살리면 된다.
 *   내린 것: SUPPLY_TREND_DASHBOARD · FP_PLAN_AGAINST_PRFM_DASHBOARD ·
 *           FP_PLAN_AGAINST_PRFM_DETAIL_DASHBOARD · PSI_BALANCE_DASHBOARD · RTF_FULFILLMENT_DASHBOARD
 *   (SALES_PLAN_DASHBOARD 목업은 SALES_PLAN_STATUS 실화면으로 대체돼 파일째 삭제됨 — 2026-09-11)
 */
import SalesStatus from "@plannel/pages/dashboard/SalesStatusDashboard";                    // DW 백엔드 연결
import InventoryStatus from "@plannel/pages/dashboard/InventoryDashboard";                  // DW 전환(백엔드 연결 예정)
import SupplyPlanStatus from "@plannel/pages/dashboard/SupplyPlanDashboard";              // DW 실데이터(목업 없음)
import SalesPlanAccuracyDashboard from "@plannel/pages/dashboard/SalesPlanAccuracyDashboard";   // DW 신규(목업 재설계 — 계획 정확도 관점)
import LocationInventoryStatus from "@plannel/pages/dashboard/LocationInventoryDashboard";       // DW 신규(RP 보충계획 관점 — 백엔드 미착수)
import SalesPlanStatus from "@plannel/pages/dashboard/SalesPlanDashboard";              // DW 신규(계획 수립·합의 과정 관점)
import PsiBalance from "@plannel/pages/dashboard/PsiBalanceDashboard";                  // DW 신규(목업 재설계 — 불균형·재배치 관점)
import SupplyTrend from "@plannel/pages/dashboard/SupplyTrendDashboard";                // DW 신규(목업 재설계 — 선적·운송 성과 관점)

/*
  Master Data Import
 */
import HrchyConfig from "./data-management/HrchyConfig";
import LocationMaster from "./data-management/LocationMaster";
import CalendarGroupMaster from "./data-management/CalendarGroupMaster";
import CycleCalendarMaster from "./data-management/CycleCalendarMaster";
import ItemMaster from "./data-management/ItemMaster";
import CustomerHrchyMaster from "./data-management/CustomerHrchyMaster";
import CustomerMaster from "./data-management/CustomerMaster";
import SalesTransactionMaster from "./data-management/SalesTransactionMaster";
import ItemHrchyMaster from "./data-management/ItemHrchyMaster";
import InventoryTransactionMaster from "./data-management/InventoryTransactionMaster";
import ShipmentTransactionMaster from "./data-management/ShipmentTransactionMaster";
import PosTransactionMaster from "./data-management/PosTransactionMaster";
import PostnMater from "./data-management/PostnMaster";
import CustomerHrchyPermission from "./data-management/HrchyPermission";
import BodMaster from "./data-management/BodMaster";
import SiteMaster from "./data-management/SiteMaster";
import LocationItem from "./data-management/LocationItem";
import BodItem from "./data-management/BodItem";
import BomMaster from "./data-management/BomMaster";
import BomDetail from "./data-management/BomDetail";
import CustomerLocation from "./data-management/CustomerLocation";
import CustomerItem from "./data-management/CustomerItem";
import SalesPlanMaster from "./data-management/SalesPlanMaster";
import FinancePlanMaster from "./data-management/FinancePlanMaster";
import WorkcenterMaster from "./data-management/WorkcenterMaster";
import Resource from "./data-management/Resource";
import Route from "./data-management/Route";
import Routing from "./data-management/ProdRouting";
import AlternateSupply from "./data-management/AlternateSupply";
import SupplierMaster from "./data-management/SupplierMaster";
import SupplierItemMaster from "./data-management/SupplierItemMaster";
import NpiProfileMaster from "./data-management/NpiProfileMaster";
import MaterialReceiptPlan from "./data-management/MaterialReceiptPlan";
import ExchangeRate from "./data-management/ExchangeRate";
import PurchaseBudget from "./data-management/PurchaseBudget";
import DataTransform from "./data-load/DataTransform";
import DataLoadValidation from "./data-load/DataLoadValidation";
import DataValidation from "./data-load/DataValidation";
import DataHistory from "./data-load/DataHistory";
import TransformHistory from "./data-load/TransformHistory";
import UnitPrice from "./data-management/UnitPrice";
import IntransitInventory from "./data-management/IntransitInventoryMaster";
import BfFeatureDate from "./data-management/BfFeatureDate";
import BfFeatureSales from "./data-management/BfFeatureSales";
import ProdOrder from "./data-management/ProdOrder";
import PurchaseOrderMaster from "@plannel/pages/data-management/PurchaseOrderMaster";
import SalesOrder from "./data-management/SalesOrder";
import SimResourceMaster from "@plannel/pages/data-management/SimResourceMaster";
import MaxProductionModel from "./data-management/MaxProductionModel";
import MaterialOrder from "./data-management/MaterialOrder";
/*
  DP Import
 */
import AccessControlAdmin from "./demand-plan/dp-config/AccessControlAdmin";
import DpSettings from "./demand-plan/dp-config/DpSettings";
import NpiHistory from "./demand-plan/dp-config/NpiHistory";
import BfAlgoRuleMgmt from "./demand-plan/dp-config/BfAlgoRuleMgmt";
import BfSettings from "./demand-plan/dp-config/BfSettings";
import BfReview from "./demand-plan/demand-management/BfReview";
import DpProcessMgmt from "./demand-plan/demand-management/DpProcessMgmt";
import DpStatusDashboard from "./demand-plan/demand-management/DpStatusDashboard";
import DpPlanVsActual from "./demand-plan/dp-reports/DpPlanVsActual";
import TopLevelItem from "./demand-plan/dp-salesAnalysis/TopLevelItem";
import ItemCustomerSummary from "./demand-plan/dp-salesAnalysis/ItemCustomerSummary";
import FeatureAnalysis from "./demand-plan/dp-salesAnalysis/BfFeatureAnalysis";
import DpTrackingReport from "./demand-plan/dp-reports/DpTrackingReport";
import TargetItemSelection from "./demand-plan/dp-config/TargetItemSelection";
import Workbench from "./demand-plan/dp-workbench/Workbench";
import ScenarioComDashboard from "./demand-plan/demand-management/ScenarioComDashboard";
import DemandNetting from "@plannel/pages/demand-plan/demand-management/DemandNetting";
import DpLifecycleMgmt from "./demand-plan/demand-management/LifecycleMgmt";
import BfLeaderboard from "./demand-plan/dp-reports/BfLeaderboard";
import BfAccuracyReport from "./demand-plan/dp-reports/BfAccuracyReport";
/*
  RP Import
 */
import FillRateDashboard from "./replenishment-plan/exception-management/FillRateDashboard";
import InventoryExceptionsDetail from "./replenishment-plan/exception-management/InventoryExceptionsDetail";
import InventoryExceptions from "./replenishment-plan/exception-management/InventoryExceptions";
import PsiSimulation from "./replenishment-plan/exception-management/PsiSimulation";
import RpPolicy from "./replenishment-plan/rp-configuration/RpPolicy";
import RpSettings from "./replenishment-plan/rp-configuration/RpSettings";
import RpDistributionNetwork from "./replenishment-plan/rp-configuration/RpDistributionNetwork";
import RpScenarioCompDashboard from "./replenishment-plan/plan-release/RpScenarioCompDashboard";
import RunRp from "./replenishment-plan/create-plan/RunRp";
import RpReview from "./replenishment-plan/create-plan/RpReview";
import RpPlanVsActual from "./replenishment-plan/reports/RpPlanVsActual";
import RpOrderList from "./replenishment-plan/reports/RpOrderList";
import RpWorkbench from "./replenishment-plan/exception-management/RpWorkbench";
import RpDemand from "./replenishment-plan/create-plan/RpDemand";
import RpMonthlyTrend from "./replenishment-plan/reports/RpMonthlyTrend";
import ExpiredInventory from "./replenishment-plan/reports/ExpiredInventory";
import ProcurementStatusReport from "@plannel/pages/replenishment-plan/reports/ProcurementStatusReport";
import ChannelPlanningReview from "./replenishment-plan/exception-management/ChannelPlanningReview";
/*
  IP Import
 */
import AbcXyzAnalysisScenarios from "./inventory-plan/abc-xyz-analysis/AbcXyzAnalysisScenarios";
import AbcXyzAnalysisResults from "./inventory-plan/abc-xyz-analysis/AbcXyzAnalysisResults";
import MonthlyByTrend from "./inventory-plan/inventory-analysis/MonthlyByTrend";
import MonthlyByTrendDetail from "./inventory-plan/inventory-analysis/MonthlyByTrendDetail";
import InventoryOverview from "./inventory-plan/inventory-analysis/InventoryOverview";
import IPComparisonDashboard from "./inventory-plan/inventory-simulation/IPComparisonDashboard";
import InventoryManagementOverview from "./inventory-plan/inventory-analysis/InventoryManagementOverview";
import TargetInventorySimulation from "./inventory-plan/inventory-simulation/TargetInventorySimulation";
import TargetInventorySimulationResults from "./inventory-plan/inventory-simulation/TargetInventorySimulationResults";
import AiRecommendation from "./ai/AiRecommendation";
import AiMarketingIntel from "./ai/AiMarketingIntel";
import AiBfScenarioPlanning from "./ai/AiBfScenarioPlanning";
import AiDpScenarioPlanning from "./ai/AiDpScenarioPlanning";
import AiIpScenarioPlanning from "./ai/AiIpScenarioPlanning";
import AiRpScenarioPlanning from "./ai/AiRpScenarioPlanning";
import AiMpScenarioPlanning from "./ai/AiMpScenarioPlanning";
import AiFpScenarioPlanning from "./ai/AiFpScenarioPlanning";
import ScenarioManage from "./ai/ScenarioManage";
import AiChatTraceViewer from "./ai/AiChatTraceViewer";
import AiLlmUsage from "./ai/AiLlmUsage";
import AiTermDefinition from "./ai/AiTermDefinition";
import TargetInventoryEvaluation from "./inventory-plan/inventory-evaluation/TargetInventoryEvaluation";
import TargetInventoryEvaluationResult from "./inventory-plan/inventory-evaluation/TargetInventoryEvaluationResult";
import SalesComparison from "./inventory-plan/inventory-analysis/SalesComparison";
import SlowMovingInventory from "./inventory-plan/inventory-analysis/SlowMovingInventory";
import IpSettings from "./inventory-plan/ip-config/IpSettings";
import SupplyInventory from "./inventory-plan/inventory-analysis/SupplyInventory";
/*
  MP Import
 */
import MpSettings from "./master-plan/mp-configuration/MpSettings";
import FloChart from "./master-plan/mp-model/FloChart";
import MpDemand from "./master-plan/create-plan/MpDemand";
import RunMP from "./master-plan/create-plan/RunMP";
import MpReview from "./master-plan/create-plan/MpReview";
import MaterialConstraints from "./master-plan/mp-configuration/MaterialConstraints";
import ProductionLimit from "./master-plan/mp-configuration/ProductionLimit";
import MpScenarioComDashboard from "./master-plan/plan-release/MpScenarioComDashboard";
import MrpReport from "./master-plan/reports/MrpReport";
import ResourceProductionPlan from "./master-plan/reports/ResourceProductionPlan";
import MrpOrderList from "./master-plan/reports/MrpOrderList";
import ResourceUtilization from "./master-plan/reports/ResourceUtilization";
import ResourceGantt from "./master-plan/resource-gantt/ResourceGantt";
import ProductionExceptions from "@plannel/pages/master-plan/exception-management/ProductionExceptions";
import ProductionExceptionsDetail from "@plannel/pages/master-plan/exception-management/ProductionExceptionsDetail";
import MpPsiSimulation from "@plannel/pages/master-plan/exception-management/MpPsiSimulation";
import OrderTracking from "@plannel/pages/master-plan/reports/OrderTracking";
import WIP from "@plannel/pages/data-management/WIP";
import MpDemandAnalysis from "@plannel/pages/master-plan/reports/MpDemandAnalysis";
import InventoryWipTracking from "@plannel/pages/master-plan/reports/InventoryWipTracking";
// import DemandPriority from "./master-plan/mp-configuration/DemandPriority";
/*
  FP Import
 */
import FpRoute from "./factory-plan/master/Route";
import FpResource from "./factory-plan/master/Resource";
import FpStock from "./factory-plan/master/Stock";
import FpWip from "./factory-plan/master/Wip";
import FpSimulationStep from "./factory-plan/simulation/SimulationStep";
import FpSimulationScenario from "./factory-plan/simulation/SimulationScenario";
import FpSimulation from "./factory-plan/simulation/Simulation";
import FpSimulationCompare from "./factory-plan/simulation/SimulationCompare";
import FpItem from "./factory-plan/master/Item";
import FpOrder from "./factory-plan/master/Order";
import FpJobChangeTime from "./factory-plan/master/jobchangetime/JobChangeTime";
import FpBor from "./factory-plan/master/bor/Bor";
import FpFlo from "./factory-plan/master/Flo";
import FpBom from "./factory-plan/master/Bom";
import FpByproduct from "./factory-plan/master/Byproduct";
import FpValidation from "./factory-plan/master/Validation";
import FpConfiguration from "./factory-plan/master/FpConfiguration";
import FpWipEohOutDashboard from "./factory-plan/dashboard/WipEohOutDashboard";
import FpVersusPerformance from "./factory-plan/dashboard/FpVersusPerformance";
import FpSimulationKpiDashboard from "./factory-plan/dashboard/SimulationKPIDashboard";
import FpPlanProblemDashboard from "./factory-plan/dashboard/PlanProblemDashboard";
import FpPlanResult from "./factory-plan/report/PlanResult";
import FpResourceUtilization from "./factory-plan/report/ResourceUtilization";
import FpResrcPlanResult from "./factory-plan/report/ResrcPlanResult";
import FpResrcWipProfile from "./factory-plan/report/ResrcWipProfile";
import FpCustomerLeadTime from "./factory-plan/report/CustomerLeadTime";
import FpProdCustomer from "./factory-plan/report/ProdCustomer";
import FpItemWipProfile from "./factory-plan/report/ItemWipProfile";
import FpInoutStatus from "./factory-plan/report/InoutStatus";
import FpMaterialPsi from "./factory-plan/report/MaterialPsi";
import FpItemLeadTime from "./factory-plan/report/ItemLeadTime";
import FpResProdPlan from "./factory-plan/report/ResProdPlan";
import FpItemCycleTime from "./factory-plan/report/ItemCycleTime";
import FpProdSalesStockStatus from "./factory-plan/report/ProdSalesStockStatus";
import FpPsiDetail from "./factory-plan/report/PsiDetail";
import FpJobChangeTimeInfo from "./factory-plan/report/JobChangeTimeInfo";
import FpDispatchList from "./factory-plan/report/DispatchList";
import FpToolAvailability from "./factory-plan/report/ToolAvailability";
import FpDeliveryStatus from "./factory-plan/report/DeliveryStatus";
import FpPlanDetail from "./factory-plan/report/PlanDetail";
import FpResourceTargetUtilization from "./factory-plan/report/ResourceTargetUtilization";
import FpStockResult from "./factory-plan/report/StockResult";
import FpOrderTracking from "./factory-plan/report/OrderTracking";
import FpInputOrderBoard from "./factory-plan/dashboard/InputOrderBoard";
import FpOrderGantt from "./factory-plan/report/OrderGantt";
import FpResourceGantt from "./factory-plan/report/ResourceGantt";
import FpAdjustmentGrid from "./factory-plan/simulation/AdjustmentGrid"
import FpAdjustmentGantt from "./factory-plan/simulation/AdjustmentGantt";

/*
  System Management Import
 */
import SignInPolicy from "./system/SignInPolicy";
import CompanyProfile from "./system/CompanyProfile";
import PersonalSettings from "./system/PersonalSettings";
import Authentication from "./system/Authentication";
import ScheduleHistory from "./system/ScheduleHistory";
import ScheduleSettings from "./system/ScheduleSettings";
import UserMgmt from "./system/UserMgmt";
import VersionMgmt from "@plannel/pages/system/VersionMgmt";
import AuditTrail from "./system/AuditTrail";
import CustomReport from "./quicksight/CustomReport";
import MeetingAgenda from "./collaboration/MeetingAgenda";
import VersionNotes from "./collaboration/VersionNotes";

/*icons*/
import AnalyticsIcon from '@mui/icons-material/Analytics';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import AppRegistrationIcon from '@mui/icons-material/AppRegistration';
import AssignmentIcon from '@mui/icons-material/Assignment';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import CloudSyncIcon from '@mui/icons-material/CloudSync';
import DashboardIcon from '@mui/icons-material/Dashboard';
import HandshakeIcon from '@mui/icons-material/Handshake';
import FactoryIcon from '@mui/icons-material/Factory';
import InputIcon from '@mui/icons-material/Input';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import WarehouseIcon from '@mui/icons-material/Warehouse';
import StorageIcon from '@mui/icons-material/Storage';
import SecurityIcon from '@mui/icons-material/Security';
import SettingsIcon from "@mui/icons-material/Settings";
import ViewInArIcon from '@mui/icons-material/ViewInAr';
import ScheduleIcon from '@mui/icons-material/Schedule';
import GroupsIcon from '@mui/icons-material/Groups';
import BusinessIcon from '@mui/icons-material/Business';
import AccountBoxIcon from '@mui/icons-material/AccountBox';
import TroubleshootIcon from '@mui/icons-material/Troubleshoot';
import DataUsageIcon from '@mui/icons-material/DataUsage';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import EventNoteOutlinedIcon from '@mui/icons-material/EventNoteOutlined';
import SpeakerNotesOutlinedIcon from '@mui/icons-material/SpeakerNotesOutlined';
import LibraryBooksIcon from '@mui/icons-material/LibraryBooks';
import DPDashboardIcon from "@mui/icons-material/BarChart";
import IPDashboardIcon from "@mui/icons-material/Inventory2Outlined";
import RPDashboardIcon from "@mui/icons-material/AccountBalance";
import InsightsRoundedIcon from '@mui/icons-material/InsightsRounded';
import LightbulbIcon from '@mui/icons-material/Lightbulb';
import CampaignIcon from '@mui/icons-material/Campaign';
/* S&OP lv2 대시보드별 아이콘 (목업 화면은 기존 DPDashboardIcon 유지) */
import PointOfSaleIcon from '@mui/icons-material/PointOfSale';
import GpsFixedIcon from '@mui/icons-material/GpsFixed';
import Inventory2Icon from '@mui/icons-material/Inventory2';
import HubIcon from '@mui/icons-material/Hub';
import PrecisionManufacturingIcon from '@mui/icons-material/PrecisionManufacturing';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import BalanceIcon from '@mui/icons-material/Balance';
import ResourceCapacity from "@plannel/pages/data-management/ResourceCapacity";
import BfTrainingAdjustment from "@plannel/pages/demand-plan/dp-config/BfTrainingAdjustment";

import quickSightService from "@plannel/services/system/quicksight-service";
import i18n from "i18next";
import ShippingAlert from "./replenishment-plan/reports/ShippingAlert";

// Module version
const MENU_GROUP = {
  CONFIG: "configurationData",
  MASTER: "masterData",
  RELATION: "relationalData",
  PLANNING: "planningData",
  TRANSACTION: "transactionalData",
}

const lv1MenuList = {
  // DASHBOARD: { /* singleMenu example */
  //   key: 9999, reduxKey: "DASHBOARD", title: "dashboard", icon: <DashboardIcon fontSize="large" />, sideBarMenu: true, singleMenu: true,
  //   // singleMenu 사용시 key 값은 lv3(leafMenu)의 key 값과 일치해야함. lv3의 화면은 기존과 동일하게 만들어주면됨.
  //   // singleMenu: true,
  //   appRoles: ["ROLE_APP_IP", "ROLE_APP_DP", "ROLE_APP_RP"]
  // },
  AI: {
    key: 6000, reduxKey: "AI_PLANNING_INTELLIGENCE", title: "menuAiPlanning", icon: <InsightsRoundedIcon fontSize="large" />, sideBarMenu: true,
    appRoles: ["ROLE_APP_AI"],
    userRoles: ["ROLE_ADMIN"]
  },
  SNOP: {
    // v26.10: S&OP 미출시 — sideBarMenu false 는 사이드바·메뉴 검색, unreleased 는 화면 링크·탭 복원까지 막는다
    key: 6100, reduxKey: "SNOP", title: "menuSnop", icon: <HandshakeIcon fontSize="large" />, sideBarMenu: false, unreleased: true,
    appRoles: ["ROLE_APP_IP", "ROLE_APP_DP", "ROLE_APP_RP", "ROLE_APP_MP"],
    userRoles: ["ROLE_ADMIN", "ROLE_DP_MGR", "ROLE_DP_USER", "ROLE_IP_MGR", "ROLE_IP_USER", "ROLE_RP_MGR", "ROLE_RP_USER", "ROLE_MP_MGR", "ROLE_MP_USER", "ROLE_GUEST"]
  },
  DASHBOARD: {
    key: 9999, reduxKey: "DASHBOARD", title: "dashboard", icon: <DashboardIcon fontSize="large" />, sideBarMenu: true,
    appRoles: ["ROLE_APP_IP", "ROLE_APP_DP", "ROLE_APP_RP", "ROLE_APP_MP"],
    userRoles: ["ROLE_ADMIN", "ROLE_DP_MGR", "ROLE_DP_USER", "ROLE_IP_MGR", "ROLE_IP_USER", "ROLE_RP_MGR", "ROLE_RP_USER", "ROLE_MP_MGR", "ROLE_MP_USER", "ROLE_GUEST"]
  },
  BI_REPORT: {
    key: 9000, reduxKey: "BI_REPORT", title: "menuBI", icon: <InsightsRoundedIcon fontSize="large" />, sideBarMenu: true,
    appRoles: ["ROLE_APP_BI"],
    userRoles: ["ROLE_ADMIN", "ROLE_DP_MGR", "ROLE_DP_USER", "ROLE_IP_MGR", "ROLE_IP_USER", "ROLE_RP_MGR", "ROLE_RP_USER", "ROLE_MP_MGR", "ROLE_MP_USER", "ROLE_GUEST"]
  },
  DEMAND_PLAN: {
    key: 1, reduxKey: "DEMAND_PLAN", title: "menuDemandPlan", icon: <AnalyticsIcon fontSize="large" />, sideBarMenu: true,
    appRoles: ["ROLE_APP_DP"],
    userRoles: ["ROLE_ADMIN", "ROLE_DP_MGR", "ROLE_DP_USER", "ROLE_GUEST"]
  },
  INVENTORY_PLAN: {
    key: 2, reduxKey: "INVENTORY_PLAN", title: "inventoryPlan", icon: <WarehouseIcon fontSize="large" />, sideBarMenu: true,
    appRoles: ["ROLE_APP_IP"],
    userRoles: ["ROLE_ADMIN", "ROLE_IP_MGR", "ROLE_IP_USER", "ROLE_GUEST"]
  },
  REPLENISHMENT_PLAN: {
    key: 3, reduxKey: "REPLENISHMENT_PLAN", title: "replenishPlan", icon: <LocalShippingIcon fontSize="large" />, sideBarMenu: true,
    appRoles: ["ROLE_APP_RP"],
    userRoles: ["ROLE_ADMIN", "ROLE_RP_MGR", "ROLE_RP_USER", "ROLE_GUEST"]
  },
  MASTER_PLAN: {
    key: 4, reduxKey: "MASTER_PLAN", title: "masterPlan", icon: <FactoryIcon fontSize="large" />, sideBarMenu: true,
    appRoles: ["ROLE_APP_MP"],
    userRoles: ["ROLE_ADMIN", "ROLE_MP_MGR", "ROLE_MP_USER", "ROLE_GUEST"]
  },
  FACTORY_PLAN: {
    key: 7, reduxKey: "FACTORY_PLAN", title: "factoryPlan", icon: <PrecisionManufacturingIcon fontSize="large" />, sideBarMenu: true,
    appRoles: ["ROLE_APP_FP"],
    userRoles: ["ROLE_ADMIN", "ROLE_FP_MGR", "ROLE_FP_USER", "ROLE_GUEST"]
  },
  DATA_INTEGRATION: {
    key: 5, reduxKey: "DATA_INTEGRATION", title: "dataIntegration", icon: <CloudSyncIcon fontSize="large" />, sideBarMenu: true,
    appRoles: ["ROLE_APP_IP", "ROLE_APP_DP", "ROLE_APP_RP", "ROLE_APP_MP"],
    userRoles: ["ROLE_ADMIN", "ROLE_DP_MGR", "ROLE_IP_MGR", "ROLE_RP_MGR", "ROLE_MP_MGR", "ROLE_DI"]
  },
  USER_ACCOUNT: {
    key: 6, reduxKey: "SETTING", title: "menuSettings", icon: <SettingsIcon fontSize="large" />, sideBarMenu: true,
    appRoles: ["ROLE_APP_IP", "ROLE_APP_DP", "ROLE_APP_RP", "ROLE_APP_MP"],
    userRoles: ["ROLE_ADMIN", "ROLE_DP_MGR", "ROLE_DP_USER", "ROLE_IP_MGR", "ROLE_IP_USER", "ROLE_RP_MGR", "ROLE_RP_USER", "ROLE_MP_MGR", "ROLE_MP_USER", "ROLE_GUEST", "ROLE_DI"]
  },
  AI_ADMIN: { // 관리자 전용 AI 운영 화면(챗 트레이스·LLM 토큰 사용량·용어 사전) 묶음
    key: 6029, reduxKey: "AI_ADMIN", title: "menuAiAdmin", icon: <AdminPanelSettingsIcon fontSize="large" />, sideBarMenu: true,
    appRoles: ["ROLE_APP_AI"],
    userRoles: ["ROLE_ADMIN"]
  }
};

const lv2MenuList = {
  AI: [
    {
      reduxKey: "AI_MARKETING_AGENT", menuCd: "AI_MARKETING_AGENT", menuTitle: "menuAiMarketingIntelligence",
      icon: <CampaignIcon />,
      userRoles: ["ROLE_ADMIN"]
    },
    {
      reduxKey: "AI_SCENARIO_PLANNING", menuCd: "AI_SCENARIO_PLANNING", menuTitle: "menuAiScenarioPlanning",
      icon: <InsightsRoundedIcon />,
      userRoles: ["ROLE_ADMIN"]
    },
  ],
  // AI: lv2 그룹 없음 → lv3[AI] 항목이 바로 하위에 평탄 표시
  INVENTORY_PLAN: [
    {
      reduxKey:"SUBMENU_IP_SETTINGS", menuCd: "SUBMENU_IP_SETTINGS", menuTitle: "menuSettings", icon: <InputIcon />,
      userRoles: ["ROLE_ADMIN", "ROLE_IP_MGR", "ROLE_IP_USER", "ROLE_GUEST"]
    },
    {
      reduxKey:"IP_PLAN", menuCd: "IP_PLAN", menuTitle: "menuPlan", icon: <AppRegistrationIcon />,
      userRoles: ["ROLE_ADMIN", "ROLE_IP_MGR", "ROLE_IP_USER", "ROLE_GUEST"]
    },
    {
      reduxKey:"INV_ANALYSIS_MONITORING", menuCd: "INV_ANALYSIS_MONITORING", menuTitle: "menuAnalysisMonitoring", icon: <AssignmentIcon />
    }
  ],
  DEMAND_PLAN: [
    {
      reduxKey:"SUBMENU_DP_SETTINGS", menuCd: "SUBMENU_DP_SETTINGS", menuTitle: "menuSettings", icon: <InputIcon />,
      userRoles: ["ROLE_ADMIN", "ROLE_DP_MGR"]
    },
    {
      reduxKey:"DP_PLAN", menuCd: "DP_PLAN", menuTitle: "menuPlan", icon: <AppRegistrationIcon />,
      userRoles: ["ROLE_ADMIN", "ROLE_DP_MGR", "ROLE_DP_USER"]
    },
    {
      reduxKey:"DP_ANALYSIS_MONITORING", menuCd: "DP_ANALYSIS_MONITORING", menuTitle: "menuAnalysisMonitoring", icon: <AssignmentIcon />
    }
  ],
  REPLENISHMENT_PLAN: [
    {
      reduxKey:"SUBMENU_RP_SETTINGS", menuCd: "SUBMENU_RP_SETTINGS", menuTitle: "menuSettings", icon: <InputIcon />,
      userRoles: ["ROLE_ADMIN", "ROLE_RP_MGR"]
    },
    {
      reduxKey:"RP_PLAN", menuCd: "RP_PLAN", menuTitle: "menuPlan", icon: <AppRegistrationIcon />,
      userRoles: ["ROLE_ADMIN", "ROLE_RP_MGR", "ROLE_RP_USER", "ROLE_GUEST"]
    },
    {
      reduxKey:"RP_ANALYSIS_MONITORING", menuCd: "RP_ANALYSIS_MONITORING", menuTitle: "menuAnalysisMonitoring", icon: <AssignmentIcon />
    }
  ],
  MASTER_PLAN: [
    {
      reduxKey:"SUBMENU_MP_SETTINGS", menuCd: "SUBMENU_MP_SETTINGS", menuTitle: "menuSettings", icon: <InputIcon />,
      userRoles: ["ROLE_ADMIN", "ROLE_MP_MGR"]
    },
    {
      reduxKey:"MP_PLAN", menuCd: "MP_PLAN", menuTitle: "menuPlan", icon: <AppRegistrationIcon />,
      userRoles: ["ROLE_ADMIN", "ROLE_MP_MGR", "ROLE_MP_USER", "ROLE_GUEST"]
    },
    {
      reduxKey:"MP_ANALYSIS_MONITORING", menuCd: "MP_ANALYSIS_MONITORING", menuTitle: "menuAnalysisMonitoring", icon: <AssignmentIcon />
    }
  ],
  FACTORY_PLAN: [
    {
      reduxKey:"FP_DASHBOARD", menuCd: "FP_DASHBOARD", menuTitle: "dashboard", icon: <DashboardIcon />,
      userRoles: ["ROLE_ADMIN", "ROLE_FP_MGR", "ROLE_FP_USER", "ROLE_GUEST"]
    },
    {
      reduxKey:"FP_SIMULATION", menuCd: "FP_SIMULATION", menuTitle: "menuFpSimulation", icon: <AppRegistrationIcon />,
      userRoles: ["ROLE_ADMIN", "ROLE_FP_MGR", "ROLE_FP_USER", "ROLE_GUEST"]
    },
    { // AI 시나리오 플래닝 — 라벨 키는 AI 대메뉴의 그룹과 같은 것을 재사용한다(같은 뜻).
      //   menuCd 는 새로 딴다 — AI_SCENARIO_PLANNING 을 재사용하면 lv3 배열 키가 충돌한다.
      //   ⚠️ appRoles 가 여기 있어야 AI 미보유 테넌트에서 **그룹 헤더째** 사라진다
      //      (Sidebar 가 lv2 도 roleCheck 한다). 없으면 빈 그룹이 남는다.
      reduxKey:"FP_SCENARIO_PLANNING", menuCd: "FP_SCENARIO_PLANNING",
      menuTitle: "menuAiScenarioPlanning", icon: <InsightsRoundedIcon />,
      appRoles: ["ROLE_APP_AI"],
      userRoles: ["ROLE_ADMIN", "ROLE_FP_MGR"]
    },
    {
      reduxKey:"FP_ANALYSIS", menuCd: "FP_ANALYSIS", menuTitle: "menuFpAnalysis", icon: <AssignmentIcon />,
      userRoles: ["ROLE_ADMIN", "ROLE_FP_MGR", "ROLE_FP_USER", "ROLE_GUEST"]
    },
    {
      reduxKey:"FP_MASTER", menuCd: "FP_MASTER", menuTitle: "menuFpMaster", icon: <InputIcon />,
      userRoles: ["ROLE_ADMIN", "ROLE_FP_MGR", "ROLE_FP_USER", "ROLE_GUEST"]
    }
  ],
  DATA_INTEGRATION: [
    {
      reduxKey:"DATA_MGMT", menuCd: "DATA_MGMT", menuTitle: "dataMgmt", icon: <StorageIcon />
    },
    {
      reduxKey:"CSV_IMPORT", menuCd: "CSV_IMPORT", menuTitle: "csvImport", icon: <CloudUploadIcon />,
      userRoles: ["ROLE_ADMIN", "ROLE_DI"]
    },
    {
      reduxKey:"BUILD_DATA_CUBE", menuCd: "BUILD_DATA_CUBE", menuTitle: "buildDataCube", icon: <ViewInArIcon />,
      userRoles: ["ROLE_ADMIN", "ROLE_DI"]
    }
  ],
  USER_ACCOUNT: [
    {
      reduxKey:"SECURITY_CONFIG", menuCd: "SECURITY_CONFIG", menuTitle: "security", icon: <SecurityIcon />
    },
    {
      reduxKey:"SCHEDULER_CONFIG", menuCd: "SCHEDULER_CONFIG", menuTitle: "jobSchedule", icon: <ScheduleIcon />,
      userRoles: ["ROLE_ADMIN"]
    }
  ]
};

const LeafIcon = () => {
  return <ArrowRightIcon sx={{ fontSize: "24px" }} />;
};

/*
  Master : 100 ~ 999
  IP : 1000 ~ 1999
  DP : 2000 ~ 2999
  RP : 3000 ~ 3999
  MP : 4000 ~ 4999
  Other : 5000 ~
*/
const lv3MenuList = {
  AI_MARKETING_AGENT: [
    { // 마케팅 인텔리전스
      key: 6015, reduxKey: "AI_MARKETING_INTEL", title: "menuAiMarketSignalCollection",
      icon: <CampaignIcon sx={{ fontSize: "24px" }} />,
      userRoles: ["ROLE_ADMIN", "ROLE_DP_MGR", "ROLE_DP_USER", "ROLE_IP_MGR", "ROLE_IP_USER",
        "ROLE_RP_MGR", "ROLE_RP_USER", "ROLE_MP_MGR", "ROLE_MP_USER", "ROLE_GUEST"],
      component: <AiMarketingIntel viewName={"AI_MARKETING_INTEL"} />
    },
    { // Market Signal Approval
      key: 6013, reduxKey: "AI_RECOMMENDATION", title: "menuAiMarketSignalApproval",
      icon: <LightbulbIcon sx={{ fontSize: "24px" }} />,
      userRoles: ["ROLE_ADMIN", "ROLE_DP_MGR", "ROLE_DP_USER", "ROLE_IP_MGR", "ROLE_IP_USER",
        "ROLE_RP_MGR", "ROLE_RP_USER", "ROLE_MP_MGR", "ROLE_MP_USER", "ROLE_GUEST"],
      component: <AiRecommendation viewName={"AI_RECOMMENDATION"} />
    }
  ],
  AI_SCENARIO_PLANNING: [
    { // BF 시나리오 플래닝 (Baseline Forecasting)
      key: 6021, reduxKey: "AI_BF_SCENARIO_PLANNING", title: "menuAiBfScenario",
      icon: <LeafIcon />,
      appRoles: ["ROLE_APP_BF"],
      userRoles: ["ROLE_ADMIN", "ROLE_DP_MGR", "ROLE_DP_USER", "ROLE_IP_MGR", "ROLE_IP_USER",
        "ROLE_RP_MGR", "ROLE_RP_USER", "ROLE_MP_MGR", "ROLE_MP_USER", "ROLE_GUEST"],
      component: <AiBfScenarioPlanning viewName={"AI_BF_SCENARIO_PLANNING"} />
    },
    { // DP 시나리오 플래닝 (Demand Planning)
      key: 6022, reduxKey: "AI_DP_SCENARIO_PLANNING", title: "menuAiDpScenario",
      icon: <LeafIcon />,
      appRoles: ["ROLE_APP_DP"],
      userRoles: ["ROLE_ADMIN", "ROLE_DP_MGR", "ROLE_DP_USER", "ROLE_IP_MGR", "ROLE_IP_USER",
        "ROLE_RP_MGR", "ROLE_RP_USER", "ROLE_MP_MGR", "ROLE_MP_USER", "ROLE_GUEST"],
      component: <AiDpScenarioPlanning viewName={"AI_DP_SCENARIO_PLANNING"} />
    },
    { // IP 시나리오 플래닝 (Inventory Planning)
      key: 6023, reduxKey: "AI_IP_SCENARIO_PLANNING", title: "menuAiIpScenario",
      icon: <LeafIcon />,
      appRoles: ["ROLE_APP_IP"],
      userRoles: ["ROLE_ADMIN", "ROLE_DP_MGR", "ROLE_DP_USER", "ROLE_IP_MGR", "ROLE_IP_USER",
        "ROLE_RP_MGR", "ROLE_RP_USER", "ROLE_MP_MGR", "ROLE_MP_USER", "ROLE_GUEST"],
      component: <AiIpScenarioPlanning viewName={"AI_IP_SCENARIO_PLANNING"} />
    },
    { // RP 시나리오 플래닝 (Replenishment Planning)
      key: 6024, reduxKey: "AI_RP_SCENARIO_PLANNING", title: "menuAiRpScenario",
      icon: <LeafIcon />,
      appRoles: ["ROLE_APP_RP"],
      userRoles: ["ROLE_ADMIN", "ROLE_RP_MGR", "ROLE_RP_USER",
        "ROLE_DP_MGR", "ROLE_DP_USER", "ROLE_IP_MGR", "ROLE_IP_USER",
        "ROLE_MP_MGR", "ROLE_MP_USER", "ROLE_GUEST"],
      component: <AiRpScenarioPlanning viewName={"AI_RP_SCENARIO_PLANNING"} />
    },
    { // MP 시나리오 플래닝 (Master Planning)
      key: 6025, reduxKey: "MP_AI_SCENARIO_PLANNING", title: "menuAiMpScenario",
      icon: <LeafIcon />,
      appRoles: ["ROLE_APP_MP"],
      userRoles: ["ROLE_ADMIN", "ROLE_MP_MGR", "ROLE_MP_USER",
        "ROLE_DP_MGR", "ROLE_DP_USER", "ROLE_IP_MGR", "ROLE_IP_USER",
        "ROLE_RP_MGR", "ROLE_RP_USER", "ROLE_GUEST"],
      component: <AiMpScenarioPlanning viewName={"MP_AI_SCENARIO_PLANNING"} />
    },
    // FP(스케줄 시나리오)는 여기 없다 — 생산계획 대메뉴의 FP_SCENARIO_PLANNING 으로 옮겼다
    //   (2026-09-08 사용자 지시). 모듈 전환 key 는 AiScenarioPlanning.MODULE_MENU_KEYS 참조.
    { // 커스텀 시나리오 관리 (전 모듈 공용, P2-A1)
      key: 6026, reduxKey: "AI_SCENARIO_MANAGE", title: "menuAiScenarioManage",
      icon: <LeafIcon />,
      userRoles: ["ROLE_ADMIN", "ROLE_DP_MGR", "ROLE_DP_USER", "ROLE_IP_MGR", "ROLE_IP_USER",
        "ROLE_RP_MGR", "ROLE_RP_USER", "ROLE_MP_MGR", "ROLE_MP_USER", "ROLE_GUEST"],
      component: <ScenarioManage viewName={"AI_SCENARIO_MANAGE"} />
    },
  ],
  SNOP: [
    /*
      회의 안건이 S&OP 의 첫 줄이다. 이 화면들은 "숫자를 본다" 이고 안건은 "그래서 무엇을
      정했나" 라, 보기 전에 무엇을 논의할지가 먼저 온다.
    */
    {
      key: 5100, reduxKey: "MEETING_AGENDA", title: "meetingAgenda",
      icon: <EventNoteOutlinedIcon />,
      component: <MeetingAgenda viewName={"MEETING_AGENDA"} title="meetingAgenda" />
    },
    // 2026-10-05 이후 공개 예정 — 그때까지 사이드바에서 숨긴다(hide). 코드·API 는 살아 있다.
    // 모듈을 가로지르는 셀 노트 모음. 권한 제한 없음 — 어느 모듈 노트를 보일지는 백엔드가 앱 권한으로 정한다.
    {
      key: 5101, reduxKey: "VERSION_NOTES", title: "versionNotes", hide: true,
      icon: <SpeakerNotesOutlinedIcon />,
      appRoles: ["ROLE_APP_DP", "ROLE_APP_RP", "ROLE_APP_MP"],
      component: <VersionNotes viewName={"VERSION_NOTES"} title="versionNotes" />
    },
    {
      key: 1122, reduxKey: "SALES_STATUS", title: "salesStatus",
      icon: <PointOfSaleIcon />,
      appRoles: ["ROLE_APP_DP"],
      userRoles: ["ROLE_ADMIN", "ROLE_DP_MGR", "ROLE_DP_USER", "ROLE_GUEST"],
      component: <SalesStatus viewName={"SALES_STATUS"} title="salesStatus" />
    },
    {
      key: 1127, reduxKey: "SALES_PLAN_STATUS", title: "salesPlanStatus",
      icon: <FactCheckIcon />,
      appRoles: ["ROLE_APP_DP"],
      userRoles: ["ROLE_ADMIN", "ROLE_DP_MGR", "ROLE_DP_USER", "ROLE_GUEST"],
      component: <SalesPlanStatus viewName={"SALES_PLAN_STATUS"} title="salesPlanStatus" />
    },
    {
      key: 1125, reduxKey: "SALES_PLAN_ACCURACY_DASHBOARD", title: "salesPlanAccuracyDashboard",
      icon: <GpsFixedIcon />,
      appRoles: ["ROLE_APP_DP"],
      userRoles: ["ROLE_ADMIN", "ROLE_DP_MGR", "ROLE_DP_USER", "ROLE_GUEST"],
      component: <SalesPlanAccuracyDashboard viewName={"SALES_PLAN_ACCURACY_DASHBOARD"} title="salesPlanAccuracyDashboard" />
    },
    {
      key: 1123, reduxKey: "INVENTORY_STATUS", title: "inventoryStatus",
      icon: <Inventory2Icon />,
      appRoles: ["ROLE_APP_IP"],
      userRoles: ["ROLE_ADMIN", "ROLE_IP_MGR", "ROLE_IP_USER", "ROLE_GUEST"],
      component: <InventoryStatus viewName={"INVENTORY_STATUS"} title="inventoryStatus" />
    },
    {
      key: 1126, reduxKey: "LOCATION_INVENTORY_STATUS", title: "locationInventoryStatus",
      icon: <HubIcon />,
      appRoles: ["ROLE_APP_RP"],
      userRoles: ["ROLE_ADMIN", "ROLE_RP_MGR", "ROLE_RP_USER", "ROLE_GUEST"],
      component: <LocationInventoryStatus viewName={"LOCATION_INVENTORY_STATUS"} title="locationInventoryStatus" />
    },
    {
      key: 1124, reduxKey: "SUPPLY_PLAN_STATUS", title: "supplyPlanStatus",
      icon: <PrecisionManufacturingIcon />,
      appRoles: ["ROLE_APP_MP", "ROLE_APP_RP"],
      userRoles: ["ROLE_ADMIN", "ROLE_MP_MGR", "ROLE_MP_USER", "ROLE_RP_MGR", "ROLE_RP_USER", "ROLE_GUEST"],
      component: <SupplyPlanStatus viewName={"SUPPLY_PLAN_STATUS"} title="supplyPlanStatus" />
    },
    {
      // 목업(dashboard_temp/PsiBalanceDashboard.js)을 축을 바꿔 재설계했다 — S/P/I 흐름은 기존 두 화면과
      //   정면 중복이라 버리고, 거점×품목 불균형·재배치만 맡는다(dashboard-spec/07_psi_balance.md §8)
      key: 1128, reduxKey: "PSI_BALANCE", title: "psiBalance",
      icon: <BalanceIcon />,
      appRoles: ["ROLE_APP_RP"],
      userRoles: ["ROLE_ADMIN", "ROLE_RP_MGR", "ROLE_RP_USER", "ROLE_GUEST"],
      component: <PsiBalance viewName={"PSI_BALANCE"} title="psiBalance" />
    },
    {
      // 목업(dashboard_temp/SupplyTrendDashboard.js)을 축을 바꿔 재설계했다 — 재고 추이·회전율은
      //   Inventory Status 와 중복이라 버리고, **아무 화면도 안 쓰던 z_fact_shipment_actual** 로
      //   운송 구간(정시율·지연 원인·lane)을 맡는다(dashboard-spec/08_supply_trend.md §6)
      key: 1129, reduxKey: "SUPPLY_TREND", title: "supplyTrend",
      icon: <LocalShippingIcon />,
      appRoles: ["ROLE_APP_RP", "ROLE_APP_MP"],
      userRoles: ["ROLE_ADMIN", "ROLE_RP_MGR", "ROLE_RP_USER", "ROLE_MP_MGR", "ROLE_MP_USER", "ROLE_GUEST"],
      component: <SupplyTrend viewName={"SUPPLY_TREND"} title="supplyTrend" />
    },
  ],
  DASHBOARD: [
    {
      key: 9999, reduxKey: "INTEGRATED_DASHBOARD", title: "integratedDashboard",
      icon: <DashboardIcon />,
      appRoles: ["ROLE_APP_IP", "ROLE_APP_RP", "ROLE_APP_DP"], singleMenu: true,
      component: <Dashboard viewName={"DASHBOARD"} title="integratedDashboard" />
    },
    {
      key: 3999, reduxKey: "DP_DASHBOARD", title: "dpDashboard",
      icon: <DPDashboardIcon />,
      appRoles: ["ROLE_APP_DP"],
      userRoles: ["ROLE_ADMIN", "ROLE_DP_MGR", "ROLE_DP_USER", "ROLE_GUEST"],
      component: <DpDashboard viewName={"DP_DASHBOARD"} title="dpDashboard" />
    },
    {
      key: 1999, reduxKey: "IP_DASHBOARD", title: "menuIpDashboard",
      icon: <IPDashboardIcon />,
      appRoles: ["ROLE_APP_IP"],
      userRoles: ["ROLE_ADMIN", "ROLE_IP_MGR", "ROLE_IP_USER", "ROLE_GUEST"],
      component: <IPDashboard viewName={"IP_DASHBOARD"} title="menuIpDashboard" />
    },
    {
      key: 2999, reduxKey: "RP_DASHBOARD", title: "rpDashboard",
      icon: <RPDashboardIcon />,
      appRoles: ["ROLE_APP_RP"],
      userRoles: ["ROLE_ADMIN", "ROLE_RP_MGR", "ROLE_RP_USER", "ROLE_GUEST"],
      component: <RpDashboard viewName={"RP_DASHBOARD"} title="rpDashboard" />
    }
  ],
  DATA_MGMT: [
    // CONFIG
    {
      key: 100, reduxKey: "INPUT_HRCHY_CONFIG", title: "hierarchyConfig",
      icon: <LeafIcon />, groupType: MENU_GROUP.CONFIG,
      component: <HrchyConfig viewName={"INPUT_HRCHY_CONFIG"} title="hierarchyConfig" />
    },
    {
      key: 101, reduxKey: "INPUT_ITEM_HRCHY", title: "itemHrchy",
      icon: <LeafIcon />, groupType: MENU_GROUP.CONFIG,
      component: <ItemHrchyMaster viewName={"INPUT_ITEM_HRCHY"} title="itemHrchy" />
    },
    {
      key: 102, reduxKey: "INPUT_CUSTOMER_HRCHY", title: "customerHierarchy",
      icon: <LeafIcon />, groupType: MENU_GROUP.CONFIG,
      appRoles: ["ROLE_APP_DP", "ROLE_APP_RP", "ROLE_APP_MP", "ROLE_APP_IP"],
      component: <CustomerHrchyMaster viewName={"INPUT_CUSTOMER_HRCHY"} title="customerHierarchy" />
    },
    {
      key: 103, reduxKey: "INPUT_POSTN", title: "postn",
      icon: <LeafIcon />, groupType: MENU_GROUP.CONFIG,
      appRoles: ["ROLE_APP_DP"],
      component: <PostnMater viewName={"INPUT_POSTN"} title="postn" />
    },
    {
      key: 104, reduxKey: "INPUT_CUSTOMER_HRCHY_PERMISSION", title: "customerHrchyPermission",
      icon: <LeafIcon />, groupType: MENU_GROUP.CONFIG,
      appRoles: ["ROLE_APP_DP"],
      component: <CustomerHrchyPermission viewName={"INPUT_CUSTOMER_HRCHY_PERMISSION"} title="customerHrchyPermission" />
    },
    {
      key: 105, reduxKey: "INPUT_CALENDAR_GRP", title: "calendarGrp",
      icon: <LeafIcon />, groupType: MENU_GROUP.CONFIG,
      appRoles: ["ROLE_APP_RP", "ROLE_APP_MP"],
      component: <CalendarGroupMaster viewName={"INPUT_CALENDAR_GRP"} title="calendarGrp" />
    },
    {
      key: 106, reduxKey: "INPUT_CALENDAR", title: "cycleCalendar",
      icon: <LeafIcon />, groupType: MENU_GROUP.CONFIG,
      appRoles: ["ROLE_APP_RP", "ROLE_APP_MP"],
      component: <CycleCalendarMaster viewName={"INPUT_CALENDAR"} title="cycleCalendar" />
    },
    {
      key: 107, reduxKey: "INPUT_EXCHANGE_RATE", title: "exchangeRate",
      icon: <LeafIcon />, groupType: MENU_GROUP.CONFIG,
      appRoles: ["ROLE_APP_DP"],
      component: <ExchangeRate viewName={"INPUT_EXCHANGE_RATE"} title="exchangeRate" />
    },
    {
      key: 108, reduxKey: "DP_BF_ALGO_RULES", title: "bfAlgoRule",
      icon: <LeafIcon />, groupType: MENU_GROUP.CONFIG,
      appRoles: ["ROLE_APP_BF"],
      component: <BfAlgoRuleMgmt viewName={"DP_BF_ALGO_RULES"} title="bfAlgoRule" />
    },
    // MASTER
    {
      key: 110, reduxKey: "INPUT_ITEM", title: "item",
      icon: <LeafIcon />, groupType: MENU_GROUP.MASTER,
      component: <ItemMaster viewName={"INPUT_ITEM"} title="item" />
    },
    {
      key: 111, reduxKey: "INPUT_CUS", title: "customer",
      icon: <LeafIcon />, groupType: MENU_GROUP.MASTER,
      component: <CustomerMaster viewName={"INPUT_CUS"} title="customer" />
    },
    {
      key: 112, reduxKey: "INPUT_SITE", title: "site",
      icon: <LeafIcon />, groupType: MENU_GROUP.MASTER,
      appRoles: ["ROLE_APP_IP", "ROLE_APP_RP", "ROLE_APP_MP"],
      component: <SiteMaster viewName={"INPUT_SITE"} title="site" />
    },
    {
      key: 113, reduxKey: "INPUT_LOC", title: "location",
      icon: <LeafIcon />, groupType: MENU_GROUP.MASTER,
      component: <LocationMaster viewName={"INPUT_LOC"} title="location" />
    },
    {
      key: 114, reduxKey: "INPUT_WORK_CENTER", title: "workcenter",
      icon: <LeafIcon />, groupType: MENU_GROUP.MASTER,
      appRoles: ["ROLE_APP_MP"],
      component: <WorkcenterMaster viewName={"INPUT_WORK_CENTER"} title="workcenter" />
    },
    {
      key: 115, reduxKey: "INPUT_PRODUCTION_RESOURCE", title: "productionResource",
      icon: <LeafIcon />, groupType: MENU_GROUP.MASTER,
      appRoles: ["ROLE_APP_MP"],
      component: <Resource viewName={"INPUT_PRODUCTION_RESOURCE"} title="productionResource" />
    },
    {
      key: 116, reduxKey: "INPUT_PRODUCTION_LIMIT", title: "maxProductionConstraint",
      icon: <LeafIcon />, groupType: MENU_GROUP.MASTER,
      appRoles: ["ROLE_APP_MP"],
      component: <ProductionLimit viewName={"INPUT_PRODUCTION_LIMIT"} title="maxProductionConstraint" />
    },
    {
      key: 117, reduxKey: "INPUT_MAX_PRODUCTION_MODEL", title: "productionItemLimit",
      icon: <LeafIcon />, groupType: MENU_GROUP.MASTER,
      appRoles: ["ROLE_APP_MP"],
      component: <MaxProductionModel viewName={"INPUT_MAX_PRODUCTION_MODEL"} title="productionItemLimit" />
    },
    {
      key: 118, reduxKey: "INPUT_SUPPLIER", title: "supplier",
      icon: <LeafIcon />, groupType: MENU_GROUP.MASTER,
      appRoles: ["ROLE_APP_MP"],
      component: <SupplierMaster viewName={"INPUT_SUPPLIER"} title="supplier" />
    },
    // RELATION
    {
      key: 120, reduxKey: "INPUT_CUST_ITEM", title: "customerItem",
      icon: <LeafIcon />, groupType: MENU_GROUP.RELATION,
      appRoles: ["ROLE_APP_DP"],
      component: <CustomerItem viewName={"INPUT_CUST_ITEM"} title="customerItem" />
    },
    {
      key: 121, reduxKey: "INPUT_LOCATION_ITEM", title: "locationItem",
      icon: <LeafIcon />, groupType: MENU_GROUP.RELATION,
      appRoles: ["ROLE_APP_RP", "ROLE_APP_MP", "ROLE_APP_IP"],
      component: <LocationItem viewName={"INPUT_LOCATION_ITEM"} title="locationItem" />
    },
    {
      key: 122, reduxKey: "INPUT_CUSTOMER_LOCATION", title: "customerLocation",
      icon: <LeafIcon />, groupType: MENU_GROUP.RELATION,
      appRoles: ["ROLE_APP_IP", "ROLE_APP_RP", "ROLE_APP_MP"],
      component: <CustomerLocation viewName={"INPUT_CUSTOMER_LOCATION"} title="customerLocation" />
    },
    {
      key: 123, reduxKey: "INPUT_SUPPLIER_ITEM", title: "supplierItem",
      icon: <LeafIcon />, groupType: MENU_GROUP.RELATION,
      appRoles: ["ROLE_APP_MP"],
      component: <SupplierItemMaster viewName={"INPUT_SUPPLIER_ITEM"} title="supplierItem" />
    },
    {
      key: 124, reduxKey: "INPUT_NPI_PROFILE", title: "npiProfile",
      icon: <LeafIcon />, groupType: MENU_GROUP.RELATION,
      appRoles: ["ROLE_APP_DP"],
      component: <NpiProfileMaster viewName={"INPUT_NPI_PROFILE"} title="npiProfile" />
    },
    {
      key: 125, reduxKey: "INPUT_BOD", title: "bod",
      icon: <LeafIcon />, groupType: MENU_GROUP.RELATION,
      appRoles: ["ROLE_APP_RP", "ROLE_APP_IP"],
      component: <BodMaster viewName={"INPUT_BOD"} title="bod" />
    },
    {
      key: 126, reduxKey: "INPUT_BOD_ITEM", title: "bodItem",
      icon: <LeafIcon />, groupType: MENU_GROUP.RELATION,
      appRoles: ["ROLE_APP_RP"],
      component: <BodItem viewName={"INPUT_BOD_ITEM"} title="bodItem" />
    },
    {
      key: 127, reduxKey: "INPUT_BOM", title: "bom",
      icon: <LeafIcon />, groupType: MENU_GROUP.RELATION,
      appRoles: ["ROLE_APP_RP", "ROLE_APP_MP", "ROLE_APP_IP"],
      component: <BomMaster viewName={"INPUT_BOM"} title="bom" />
    },
    {
      key: 128, reduxKey: "INPUT_BOM_TREE", title: "bomDetail",
      icon: <LeafIcon />, groupType: MENU_GROUP.RELATION,
      appRoles: ["ROLE_APP_RP", "ROLE_APP_MP", "ROLE_APP_IP"],
      component: <BomDetail viewName={"INPUT_BOM_TREE"} title="bomDetail" />
    },
    {
      key: 129, reduxKey: "INPUT_PRODUCTION_ROUTE", title: "productionRoute",
      icon: <LeafIcon />, groupType: MENU_GROUP.RELATION,
      appRoles: ["ROLE_APP_MP"],
      component: <Route viewName={"INPUT_PRODUCTION_ROUTE"} title="productionRoute" />
    },
    {
      key: 130, reduxKey: "INPUT_PRODUCTION_ROUTING", title: "routing",
      icon: <LeafIcon />, groupType: MENU_GROUP.RELATION,
      appRoles: ["ROLE_APP_MP"],
      component: <Routing viewName={"INPUT_PRODUCTION_ROUTING"} title="routing" />
    },
    {
      key: 131, reduxKey: "INPUT_SIM_RESOURCE", title: "simResource",
      icon: <LeafIcon />, groupType: MENU_GROUP.RELATION,
      appRoles: ["ROLE_APP_MP"],
      component: <SimResourceMaster viewName={"INPUT_SIM_RESOURCE"} title="simResource" />
    },
    {
      key: 132, reduxKey: "RESOURCE_CAPACITY", title: "menuResourceCapacity",
      icon: <LeafIcon />, groupType: MENU_GROUP.RELATION,
      appRoles: ["ROLE_APP_MP"],
      component: <ResourceCapacity viewName={"RESOURCE_CAPACITY"} title="menuResourceCapacity" />
    },
    {
      key: 133, reduxKey: "INPUT_UNIT_PRICE", title: "unitPrice",
      icon: <LeafIcon />, groupType: MENU_GROUP.RELATION,
      appRoles: ["ROLE_APP_DP"],
      component: <UnitPrice viewName={"INPUT_UNIT_PRICE"} title="unitPrice" />
    },
    {
      key: 134, reduxKey: "INPUT_ALT_SUPPLY", title: "alternateSupply",
      icon: <LeafIcon />, groupType: MENU_GROUP.RELATION,
      appRoles: ["ROLE_APP_MP"],
      component: <AlternateSupply viewName={"INPUT_ALT_SUPPLY"} title="alternateSupply" />
    },
    // PLANNING
    {
      key: 140, reduxKey: "INPUT_FINANCE_PLAN", title: "financePlan",
      icon: <LeafIcon />, groupType: MENU_GROUP.PLANNING,
      appRoles: ["ROLE_APP_DP"],
      component: <FinancePlanMaster viewName={"INPUT_FINANCE_PLAN"} title="financePlan" />
    },
    {
      key: 141, reduxKey: "INPUT_SALES_PLAN", title: "salesPlan",
      icon: <LeafIcon />, groupType: MENU_GROUP.PLANNING,
      appRoles: ["ROLE_APP_DP", "ROLE_APP_RP"],
      component: <SalesPlanMaster viewName={"INPUT_SALES_PLAN"} title="salesPlan" />
    },
    {
      key: 142, reduxKey: "INPUT_PURCHASE_BUDGET", title: "purchaseBudget",
      icon: <LeafIcon />, groupType: MENU_GROUP.PLANNING,
      appRoles: ["ROLE_APP_RP"],
      component: <PurchaseBudget viewName={"INPUT_PURCHASE_BUDGET"} title="purchaseBudget" />
    },
    {
      key: 143, reduxKey: "INPUT_MATERIAL_RECEIPT_PLAN", title: "materialReceiptPlan",
      icon: <LeafIcon />, groupType: MENU_GROUP.PLANNING,
      appRoles: ["ROLE_APP_MP"],
      component: <MaterialReceiptPlan viewName={"INPUT_MATERIAL_RECEIPT_PLAN"} title="materialReceiptPlan" />
    },
    // TRANSACTION
    {
      key: 150, reduxKey: "BF_FEATURES_DATE", title: "bfFeatureDate",
      icon: <LeafIcon />, groupType: MENU_GROUP.TRANSACTION,
      appRoles: ["ROLE_APP_BF"],
      component: <BfFeatureDate viewName={"BF_DATE_FEATURES"} title="bfFeatureDate" />
    },
    {
      key: 151, reduxKey: "BF_FEATURES_SALES", title: "bfFeatureSales",
      icon: <LeafIcon />, groupType: MENU_GROUP.TRANSACTION,
      appRoles: ["ROLE_APP_BF"],
      component: <BfFeatureSales viewName={"BF_FEATURES_SALES"} title="bfFeatureSales" />
    },
    {
      key: 152, reduxKey: "INPUT_SALES_ORDER", title: "salesOrder",
      icon: <LeafIcon />, groupType: MENU_GROUP.TRANSACTION,
      appRoles: ["ROLE_APP_DP", "ROLE_APP_RP", "ROLE_APP_MP"],
      component: <SalesOrder viewName={"INPUT_SALES_ORDER"} title="salesOrder" />
    },
    {
      key: 153, reduxKey: "INPUT_PROD_ORDER", title: "prodOrder",
      icon: <LeafIcon />, groupType: MENU_GROUP.TRANSACTION,
      appRoles: ["ROLE_APP_MP"],
      component: <ProdOrder viewName={"INPUT_PROD_ORDER"} title="prodOrder" />
    },
    {
      key: 154, reduxKey: "INPUT_MATERIAL_ORDER", title: "materialDemand",
      icon: <LeafIcon />, groupType: MENU_GROUP.TRANSACTION,
      appRoles: ["ROLE_APP_MP"],
      component: <MaterialOrder viewName={"INPUT_MATERIAL_ORDER"} title="materialDemand" />
    },
    {
      key: 155, reduxKey: "INPUT_PURCHASE_ORDER", title: "menuPurchaseOrder",
      icon: <LeafIcon />, groupType: MENU_GROUP.TRANSACTION,
      appRoles: ["ROLE_APP_RP"],
      component: <PurchaseOrderMaster viewName={"INPUT_PURCHASE_ORDER"} title="menuPurchaseOrder" />
    },
    {
      key: 156, reduxKey: "WIP", title: "wip",
      icon: <LeafIcon />, groupType: MENU_GROUP.TRANSACTION,
      appRoles: ["ROLE_APP_MP"],
      component: <WIP viewName={"WIP"} title="wip" />
    },
    {
      key: 157, reduxKey: "INTRANSIT_INV", title: "intransitInventory",
      icon: <LeafIcon />, groupType: MENU_GROUP.TRANSACTION,
      component: <IntransitInventory viewName={"INTRANSIT_INV"} title="intransitInventory" />
    },
    {
      key: 158, reduxKey: "INPUT_SALES_TXN", title: "salesTransaction",
      icon: <LeafIcon />, groupType: MENU_GROUP.TRANSACTION,
      component: <SalesTransactionMaster viewName={"INPUT_SALES_TXN"} title="salesTransaction" />
    },
    {
      key: 159, reduxKey: "INPUT_INVENTORY_TXN", title: "inventoryTransaction",
      icon: <LeafIcon />, groupType: MENU_GROUP.TRANSACTION,
      component: <InventoryTransactionMaster viewName={"INPUT_INVENTORY_TXN"} title="inventoryTransaction" />
    },
    {
      key: 160, reduxKey: "INPUT_SHIPMENT_TXN", title: "shipmentTransaction",
      icon: <LeafIcon />, groupType: MENU_GROUP.TRANSACTION,
      appRoles: ["ROLE_APP_IP", "ROLE_APP_RP"],
      component: <ShipmentTransactionMaster viewName={"INPUT_SHIPMENT_TXN"} title="shipmentTransaction" />
    },
    {
      key: 161, reduxKey: "INPUT_POS_TXN", title: "posTransaction",
      icon: <LeafIcon />, groupType: MENU_GROUP.TRANSACTION, hide: true, unreleased: true, // v26.10 미출시 (POS)
      component: <PosTransactionMaster viewName={"INPUT_POS_TXN"} title="posTransaction" />
    }
  ],
  CSV_IMPORT: [
    {
      key: 200, reduxKey: "FILE_UPLOAD_VALIDATION", title: "fileUploadValidation",
      icon: <LeafIcon />,
      component: <DataLoadValidation viewName={"FILE_UPLOAD_VALIDATION"} title="fileUploadValidation" />
    },
    {
      key: 201, reduxKey: "DATA_VALIDATION", title: "dataValidation",
      icon: <LeafIcon />,
      component: <DataValidation viewName={"DATA_VALIDATION"} title="dataValidation" />
    },
    {
      key: 202, reduxKey: "IMPORT_HISTORY", title: "importHistory",
      icon: <LeafIcon />,
      component: <DataHistory viewName={"IMPORT_HISTORY"} title="importHistory" />
    }
  ],
  BUILD_DATA_CUBE: [
    {
      key: 300, reduxKey: "DATA_TRANSFORM", title: "dataTransform",
      icon: <LeafIcon />,
      component: <DataTransform viewName={"DATA_TRANSFORM"} title="dataTransform" />
    },
    {
      key: 301, reduxKey: "TRANSFORM_HISTORY", title: "transformHistory",
      icon: <LeafIcon />,
      component: <TransformHistory viewName={"TRANSFORM_HISTORY"} title="transformHistory" />
    }
  ],
  USER_ACCOUNT: [
    {
      key: 400, reduxKey: "PERSONAL_SETTING", title: "personalSettings",
      icon: <AccountBoxIcon />,
      component: <PersonalSettings title="personalSettings" />
    },
    {
      key: 401, reduxKey: "COMPANY_PROFILE", title: "companyProfile",
      icon: <BusinessIcon />,
      userRoles: ["ROLE_ADMIN"],
      component: <CompanyProfile viewName={"COMPANY_PROFILE"} title="companyProfile" />
    },
    {
      key: 402, reduxKey: "USER_MGMT", title: "userMgmt",
      icon: <GroupsIcon />,
      userRoles: ["ROLE_ADMIN"],
      component: <UserMgmt viewName={"USER_MGMT"} title="userMgmt" />
    },
    {
      key: 403, reduxKey: "VERSION_MGMT", title: "versionMgmt",
      icon: <LibraryBooksIcon />,
      userRoles: ["ROLE_ADMIN"],
      component: <VersionMgmt viewName={"VERSION_MGMT"} title="versionMgmt" />
    },
    {
      key: 404, reduxKey: "AUDIT_TRAIL", title: "auditTrail",
      icon: <TroubleshootIcon />,
      userRoles: ["ROLE_ADMIN"],
      component: <AuditTrail viewName={"AUDIT_TRAIL"} title="auditTrail" />
    },
    {
      key: 405, reduxKey: "AUDIT_TRAIL_DETAIL", title: "auditTrailDetail", hide: true,
      icon: <LeafIcon />,
      userRoles: ["ROLE_ADMIN"],
      component: <AuditTrail viewName={"AUDIT_TRAIL_DETAIL"} title="auditTrailDetail" />
    }
  ],
  SECURITY_CONFIG: [
    {
      key: 410, reduxKey: "AUTHENTICATION", title: "authentication",
      icon: <LeafIcon />,
      component: <Authentication title="authentication" />
    },
    {
      key: 411, reduxKey: "SIGN_IN_POLICY", title: "signInPolicy",
      icon: <LeafIcon />, userRoles: ["ROLE_ADMIN"],
      component: <SignInPolicy title="signInPolicy" />
    },
  ],
  SCHEDULER_CONFIG: [
    {
      key: 420, reduxKey: "SCHEDULE_SETTING", title: "scheduleSettings",
      icon: <LeafIcon />,
      component: <ScheduleSettings title="scheduleSettings" />
    },
    {
      key: 421, reduxKey: "SCHEDULE_HISTORY", title: "scheduleHistory",
      icon: <LeafIcon />,
      component: <ScheduleHistory viewName={"SCHEDULE_HISTORY"} title="scheduleHistory" />
    },
  ],
  SUBMENU_IP_SETTINGS: [
    {
      key: 1000, reduxKey: "IP_SETTINGS", title: "menuIpSettings",
      icon: <LeafIcon />,
      userRoles: ["ROLE_ADMIN", "ROLE_IP_MGR"],
      component: <IpSettings viewName={"IP_SETTINGS"} title="menuIpSettings" />
    },
    {
      key: 1001, reduxKey: "ABC_XYZ_SCENARIOS", title: "menuIpAbcXyzAnalysis",
      icon: <LeafIcon />,
      userRoles: ["ROLE_ADMIN", "ROLE_IP_MGR", "ROLE_IP_USER"],
      component: <AbcXyzAnalysisScenarios viewName={"ABC_XYZ_SCENARIOS"} title="menuIpAbcXyzAnalysis" />
    },
    {
      key: 1002, reduxKey: "ABC_XYZ_RESULTS", title: "menuIpAbcXyzAnalysisResult",
      icon: <LeafIcon />,
      userRoles: ["ROLE_ADMIN", "ROLE_IP_MGR", "ROLE_IP_USER", "ROLE_GUEST"],
      component: <AbcXyzAnalysisResults viewName={"ABC_XYZ_RESULTS"} title="menuIpAbcXyzAnalysisResult" />
    }
  ],
  IP_PLAN: [
    { // Manage Simulation Scenario.
      key: 1100, reduxKey: "TARGET_INV_SIMULATION", title: "menuIpTargetInvSimulation",
      icon: <LeafIcon />,
      userRoles: ["ROLE_ADMIN", "ROLE_IP_MGR", "ROLE_IP_USER"],
      component: <TargetInventorySimulation viewName={"TARGET_INV_SIMULATION"} title="menuIpTargetInvSimulation" />
    },
    { // View Simulation Result.
      key: 1101, reduxKey: "TARGET_INV_SIMULATION_RESULTS", title: "menuIpTargetInvSimulationResult",
      icon: <LeafIcon />,
      userRoles: ["ROLE_ADMIN", "ROLE_IP_MGR", "ROLE_IP_USER", "ROLE_GUEST"],
      component: <TargetInventorySimulationResults viewName={"TARGET_INV_SIMULATION_RESULTS"} title="menuIpTargetInvSimulationResult" />
    },
    { // Compare Scenarios.
      key: 1102, reduxKey: "IP_SCENARIO_COMP", title: "menuIpScenarioComparisonDashboard",
      icon: <LeafIcon />,
      userRoles: ["ROLE_ADMIN", "ROLE_IP_MGR"],
      component: <IPComparisonDashboard viewName={"IP_SCENARIO_COMP"} title="menuIpScenarioComparisonDashboard" />
    },
  ],
  INV_ANALYSIS_MONITORING: [
    { // Inventory Management Overview
      key: 1201, reduxKey: "INV_MGMT_OVERVIEW", title: "menuIpInventoryMgmtOverview",
      icon: <LeafIcon />,
      component: <InventoryManagementOverview viewName={"INV_MGMT_OVERVIEW"} title="menuIpInventoryMgmtOverview" />
    },
    {// Inventory Overview (Location + Category)
      key: 1202, reduxKey: "INV_OVERVIEW", title: "menuIpInventoryOverview",
      icon: <LeafIcon />,
      component: <InventoryOverview viewName={"INV_OVERVIEW"} title="menuIpInventoryOverview" />
    },
    { // Monthly Inventory Trend
      key: 1203, reduxKey: "INV_MON_TREND", title: "menuIpMonthlyInventoryTrend",
      icon: <LeafIcon />,
      component: <MonthlyByTrend viewName={"INV_MON_TREND"} title="menuIpMonthlyInventoryTrend" />
    },
    { // Monthly Inventory Trend Detail
      key: 1204, reduxKey: "INV_MON_TREND_DETAIL", title: "menuIpMonthlyInventoryTrendDetail",
      icon: <LeafIcon />,
      component: <MonthlyByTrendDetail viewName={"INV_MON_TREND_DETAIL"} title="menuIpMonthlyInventoryTrendDetail" />
    },
    { // Slow Moving Inventory
      key: 1205, reduxKey: "SLOW_MOVING_INVENTORY", title: "menuIpSlowMovingInventory",
      icon: <LeafIcon />,
      component: <SlowMovingInventory viewName={"SLOW_MOVING_INVENTORY"} title="menuIpSlowMovingInventory" />
    },
    { // Sales Comparison by Category
      key: 1206, reduxKey: "INV_SC", title: "menuIpSalesComparison",
      icon: <LeafIcon />,
      component: <SalesComparison viewName={"INV_SC"} title="menuIpSalesComparison" />
    },
    {
      key: 1207, reduxKey: "TARGET_INV_EVAL", title: "menuIpTargetInvEval",
      icon: <LeafIcon />,
      userRoles: ["ROLE_ADMIN", "ROLE_IP_MGR"],
      component: <TargetInventoryEvaluation viewName={"TARGET_INV_EVAL"} title="menuIpTargetInvEval" />
    },
    {
      key: 1208, reduxKey: "TARGET_INV_EVAL_RESULT", title: "menuIpTargetInvEvalResult",
      icon: <LeafIcon />,
      component: <TargetInventoryEvaluationResult viewName={"TARGET_INV_EVAL_RESULT"} title="menuIpTargetInvEvalResult" />
    },
    {
      key: 1209, reduxKey: "SUPPLY_IMVENTORY", title: "menuIpSupplyInventory",
      icon: <LeafIcon />,
      component: <SupplyInventory viewName={"SUPPLY_IMVENTORY"} title="menuIpSupplyInventory" />
    }
  ],
  SUBMENU_RP_SETTINGS: [
    {
      key: 2000, reduxKey: "RP_SETTINGS", title: "menuRpSettings",
      icon: <LeafIcon />,
      component: <RpSettings viewName={"RP_SETTINGS"} title="menuRpSettings" />
    },
    {
      key: 2001, reduxKey: "RP_DIST_NETWORK", title: "menuRpDistributionNetwork",
      icon: <LeafIcon />,
      component: <RpDistributionNetwork viewName={"RP_DIST_NETWORK"} title="menuRpDistributionNetwork" />
    },
    {
      key: 2002, reduxKey: "RP_POLICY", title: "menuRpPolicy",
      icon: <LeafIcon />,
      component: <RpPolicy viewName={"RP_POLICY"} title="menuRpPolicy" />
    },
    {
      key: 2003, reduxKey: "RP_DEMAND", title: "menuRpDemand",
      icon: <LeafIcon />,
      component: <RpDemand viewName={"RP_DEMAND"} title="menuRpDemand" />
    }
  ],
  RP_PLAN: [
    {
      key: 2100, reduxKey: "RUN_REPLENISHMENT_PLAN", title: "menuRpRun",
      icon: <LeafIcon />,
      userRoles: ["ROLE_ADMIN", "ROLE_RP_MGR", "ROLE_RP_USER"],
      component: <RunRp viewName={"RUN_REPLENISHMENT_PLAN"} title="menuRpRun" />
    },
    {
      key: 2101, reduxKey: "RP_REVIEW", title: "menuRpReview",
      icon: <LeafIcon />,
      userRoles: ["ROLE_ADMIN", "ROLE_RP_MGR", "ROLE_RP_USER", "ROLE_GUEST"],
      component: <RpReview viewName={"RP_REVIEW"} title="menuRpReview" />
    },
    {
      key: 2102, reduxKey: "PSI_SIMULATION", title: "menuRpPsiSimulation",
      icon: <LeafIcon />,
      userRoles: ["ROLE_ADMIN", "ROLE_RP_MGR", "ROLE_RP_USER"],
      component: <PsiSimulation viewName={"PSI_SIMULATION"} title="menuRpPsiSimulation" />
    },
    {
      key: 2103, reduxKey: "FILL_RATE_DASHBOARD", title: "menuRpFillRateDashboard",
      icon: <LeafIcon />,
      userRoles: ["ROLE_ADMIN", "ROLE_RP_MGR", "ROLE_RP_USER"],
      component: <FillRateDashboard viewName={"FILL_RATE_DASHBOARD"} title="menuRpFillRateDashboard" />
    },
    {
      key: 2104, reduxKey: "INV_EXC", title: "menuRpInventoryExceptions",
      icon: <LeafIcon />,
      userRoles: ["ROLE_ADMIN", "ROLE_RP_MGR", "ROLE_RP_USER"],
      component: <InventoryExceptions viewName={"INV_EXC"} title="menuRpInventoryExceptions" />
    },
    {
      key: 2105, reduxKey: "INV_EXC_DETAIL", title: "menuRpInventoryExceptionsDetail",
      icon: <LeafIcon />,
      userRoles: ["ROLE_ADMIN", "ROLE_RP_MGR", "ROLE_RP_USER"],
      component: <InventoryExceptionsDetail viewName={"INV_EXC_DETAIL"} title="menuRpInventoryExceptionsDetail" />
    },
    {
      key: 2106, reduxKey: "CHANNEL_PLANNING_REVIEW", title: "menuRpDemandSimulation",
      icon: <LeafIcon />, hide: true, unreleased: true, // v26.10 미출시 (Channel Planning · POS)
      userRoles: ["ROLE_ADMIN", "ROLE_RP_MGR", "ROLE_RP_USER"],
      component: <ChannelPlanningReview viewName={"CHANNEL_PLANNING_REVIEW"} title="menuRpDemandSimulation" />
    },
    {
      key: 2107, reduxKey: "RP_SCENARIO_COMP", title: "menuRpScenarioComparisonDashboard",
      icon: <LeafIcon />,
      userRoles: ["ROLE_ADMIN", "ROLE_RP_MGR"],
      component: <RpScenarioCompDashboard viewName={"RP_SCENARIO_COMP"} title="menuRpScenarioComparisonDashboard" />
    }
  ],
  RP_ANALYSIS_MONITORING: [
    {
      key: 2200, reduxKey: "RP_ORDER_LIST", title: "menuRpOrderList",
      icon: <LeafIcon />,
      component: <RpOrderList viewName={"RP_ORDER_LIST"} title="menuRpOrderList" />
    },
    {
      key: 2201, reduxKey: "RP_PLAN_ACTUAL", title: "menuRpPlanVsActual",
      icon: <LeafIcon />,
      component: <RpPlanVsActual viewName={"RP_PLAN_ACTUAL"} title="menuRpPlanVsActual" />
    },
    {
      key: 2202, reduxKey: "RP_MONTHLY_TREND", title: "menuRpMonthlyTrend",
      icon: <LeafIcon />,
      component: <RpMonthlyTrend viewName={"RP_MONTHLY_TREND"} title="menuRpMonthlyTrend" />
    },
    {
      key: 2203, reduxKey: "RP_PROCUREMENT_STATUS", title: "menuRpProcurementStatus",
      icon: <LeafIcon />,
      component: <ProcurementStatusReport viewName={"RP_PROCUREMENT_STATUS"} title="menuRpProcurementStatus" />
    },
    {
      key: 2204, reduxKey: "EXPIRED_INVENTORY", title: "menuRpExpiredInventory",
      icon: <LeafIcon />,
      component: <ExpiredInventory viewName={"EXPIRED_INVENTORY"} title="menuRpExpiredInventory" />
    },
    {
      key: 2205, reduxKey: "RP_WORKBENCH", title: "menuRpWorkbench",
      icon: <LeafIcon />, hide: true,
      component: <RpWorkbench viewName={"RP_WORKBENCH"} title="menuRpWorkbench" />
    },
    {
      key: 2206, reduxKey: "RP_SHIPPING_ALERT", title: "menuRpShippingAlert",
      icon: <LeafIcon />,
      component: <ShippingAlert viewName={"RP_SHIPPING_ALERT"} title="menuRpShippingAlert" />
    },
  ],
  SUBMENU_DP_SETTINGS: [
    {
      key: 3000, reduxKey: "BF_SETTINGS", title: "menuBfSettings",
      icon: <LeafIcon />,
      appRoles: ["ROLE_APP_BF"],
      component: <BfSettings viewName={"BF_SETTINGS"} title="menuBfSettings" />
    },
    {
      key: 3001, reduxKey: "TARGET_ITEM_SELECTION", title: "menuDpTargetItemSelection",
      icon: <LeafIcon />,
      component: <TargetItemSelection viewName={"TARGET_ITEM_SELECTION"} title="menuDpTargetItemSelection" />
    },
    {
      key: 3002, reduxKey: "DP_SETTINGS", title: "menuDpSettings",
      icon: <LeafIcon />,
      component: <DpSettings viewName={"DP_SETTINGS"} title="menuDpSettings" />
    },
    {
      key: 3003, reduxKey: "INPUT_BF_TRAINING_ADJ", title: "menuBfTrainingDataAdj",
      icon: <LeafIcon />,
      appRoles: ["ROLE_APP_BF"],
      component: <BfTrainingAdjustment viewName={"INPUT_BF_TRAINING_ADJ"} title="menuBfTrainingDataAdj" />
    },
    {
      key: 3004, reduxKey: "DP_NPI_HISTORY", title: "menuDpNpiHistory",
      icon: <LeafIcon />,
      appRoles: ["ROLE_APP_BF"],
      component: <NpiHistory viewName={"DP_NPI_HISTORY"} title="menuDpNpiHistory" />
    },
    {
      key: 3005, reduxKey: "DP_LIFECYCLE_MGMT", title: "menuDpLifecycleMgmt",
      icon: <LeafIcon />,
      appRoles: ["ROLE_APP_BF"],
      component: <DpLifecycleMgmt viewName={"DP_LIFECYCLE_MGMT"} title="menuDpLifecycleMgmt" />
    },
    {
      key: 3006, reduxKey: "DP_ACCESSCONTROLADMIN", title: "menuDpAccessControlAdmin",
      icon: <LeafIcon />,
      component: <AccessControlAdmin viewName={"DP_ACCESSCONTROLADMIN"} title="menuDpAccessControlAdmin" />
    }
  ],
  DP_PLAN: [
    {
      key: 3100, reduxKey: "DP_PROCESS_MGMT", title: "menuDpProcessMgmt",
      icon: <LeafIcon />,
      userRoles: ["ROLE_ADMIN", "ROLE_DP_MGR"],
      component: <DpProcessMgmt viewName={"DP_PROCESS_MGMT"} title="menuDpProcessMgmt" />
    },
    {
      key: 3101, reduxKey: "BF_REVIEW", title: "menuBfReview",
      icon: <LeafIcon />,
      appRoles: ["ROLE_APP_BF"],
      component: <BfReview viewName={"BF_REVIEW"} title="menuBfReview" />
    },
    {
      key: 3102, reduxKey: "DP_WORKBENCH", title: "menuDpPractitionerWorkbench",
      icon: <LeafIcon />,
      component: <Workbench viewName={"DP_WORKBENCH"} title="menuDpPractitionerWorkbench" />
    },
    {
      key: 3103, reduxKey: "DP_CHANNEL_WORKBENCH", title: "menuDpChannelWorkbench",
      icon: <LeafIcon />, hide: true, unreleased: true, // v26.10 미출시 (Channel Planning · POS)
      component: <Workbench viewName={"DP_CHANNEL_WORKBENCH"} title="menuDpChannelWorkbench" />
    },
    {
      key: 3104, reduxKey: "SCENARIO_COM_DB", title: "menuDpScenarioComDb",
      icon: <LeafIcon />,
      userRoles: ["ROLE_ADMIN", "ROLE_DP_MGR"],
      component: <ScenarioComDashboard viewName={"SCENARIO_COM_DB"} title="menuDpScenarioComDb" />
    },
    {
      key: 3105, reduxKey: "DP_DEMAND_NETTING", title: "menuDpDemandNetting",
      icon: <LeafIcon />, hide: true, unreleased: true, // v26.10 미출시
      component: <DemandNetting viewName={"DP_DEMAND_NETTING"} title="menuDpDemandNetting" />
    }
  ],
  DP_ANALYSIS_MONITORING: [
    {
      key: 3201, reduxKey: "TOP_LEVEL_ITEM", title: "menuDpTopLevelItem",
      icon: <LeafIcon />,
      component: <TopLevelItem viewName={"TOP_LEVEL_ITEM"} title="menuDpTopLevelItem" />
    },
    {
      key: 3202, reduxKey: "ITEM_CUSTOMER_SUMMARY", title: "menuDpItemCustomerSummary",
      icon: <LeafIcon />,
      component: <ItemCustomerSummary viewName={"ITEM_CUSTOMER_SUMMARY"} title="menuDpItemCustomerSummary" />
    },
    {
      key: 3203, reduxKey: "FEATURE_ANALYSIS", title: "menuBfFeatureAnalysis",
      icon: <LeafIcon />,
      appRoles: ["ROLE_APP_BF"],
      component: <FeatureAnalysis viewName={"FEATURE_ANALYSIS"} title="menuBfFeatureAnalysis" />
    },
    {
      key: 3204, reduxKey: "DP_STATUS_DB", title: "menuDpStatusDashboard",
      icon: <LeafIcon />,
      component: <DpStatusDashboard viewName={"DP_STATUS_DB"} title="menuDpStatusDashboard" />
    },
    {
      key: 3205, reduxKey: "DP_ACTUAL_PLAN", title: "menuDpPlanVsActual",
      icon: <LeafIcon />,
      component: <DpPlanVsActual viewName={"DP_ACTUAL_PLAN"} title="menuDpPlanVsActual" />
    },
    {
      key: 3206, reduxKey: "DP_ACTUAL_PLAN_CUM", title: "menuDpPlanVsActualCum",
      icon: <LeafIcon />,
      component: <DpPlanVsActual viewName={"DP_ACTUAL_PLAN_CUM"} title="menuDpPlanVsActualCum" />
    },
    {
      key: 3207, reduxKey: "DP_TRACKING_REPORT", title: "menuDpTrackingReport",
      icon: <LeafIcon />,
      component: <DpTrackingReport viewName={"DP_TRACKING_REPORT"} title="menuDpTrackingReport" />
    },
    {
      key: 3208, reduxKey: "BF_LEADERBOARD", title: "menuBfLeaderboard",
      appRoles: ["ROLE_APP_BF"],
      icon: <LeafIcon />,
      component: <BfLeaderboard viewName={"BF_LEADERBOARD"} title="menuBfLeaderboard" />
    },
    {
      key: 3209, reduxKey: "BF_ACCURACY_REPORT", title: "menuBfAccuracyReport",
      appRoles: ["ROLE_APP_BF"],
      icon: <LeafIcon />,
      component: <BfAccuracyReport viewName={"BF_ACCURACY_REPORT"} title="menuBfAccuracyReport" />
    }
  ],
  SUBMENU_MP_SETTINGS: [
    {
      key: 4000, reduxKey: "MP_SETTINGS", title: "menuMpSettings",
      icon: <LeafIcon />,
      component: <MpSettings viewName={"MP_SETTINGS"} title="menuMpSettings" />
    },
    {
      key: 4001, reduxKey: "MATERIAL_CONSTRAINTS", title: "menuMpMaterialConstraints",
      icon: <LeafIcon />,
      component: <MaterialConstraints viewName={"MATERIAL_CONSTRAINTS"} title="menuMpMaterialConstraints" />
    },
    {
      key: 4002, reduxKey: "MP_DEMAND", title: "menuMpDemand",
      icon: <LeafIcon />,
      component: <MpDemand viewName={"MP_DEMAND"} title="menuMpDemand" />
    },
    {
      key: 4010, reduxKey: "MP_FLO_CHART", title: "menuMpFloChart",
      icon: <LeafIcon />,
      component: <FloChart viewName={"MP_FLO_CHART"} title="menuMpFloChart" />
    },
    // {
    //   key: 4003, reduxKey: "MP_DEMAND_PRIORITY", title: "menuMpDemandPriority",
    //   icon: <LeafIcon />,
    //   component: <DemandPriority viewName={"MP_DEMAND_PRIORITY"} title="menuMpDemandPriority" />
    // },
  ],
  MP_PLAN: [
    {
      key: 4100, reduxKey: "MP_RUN", title: "menuMpRun",
      icon: <LeafIcon />,
      userRoles: ["ROLE_ADMIN", "ROLE_MP_MGR", "ROLE_MP_USER"],
      component: <RunMP viewName={"MP_RUN"} title="menuMpRun" />
    },
    {
      key: 4101, reduxKey: "MP_PLAN_REVIEW", title: "menuMpReview",
      icon: <LeafIcon />,
      userRoles: ["ROLE_ADMIN", "ROLE_MP_MGR", "ROLE_MP_USER", "ROLE_GUEST"],
      component: <MpReview viewName={"MP_PLAN_REVIEW"} title="menuMpReview" />
    },
    {
      key: 4102, reduxKey: "MP_PSI_SIMULATION", title: "menuMpPsiSimulation",
      icon: <LeafIcon />,
      userRoles: ["ROLE_ADMIN", "ROLE_MP_MGR", "ROLE_MP_USER"],
      component: <MpPsiSimulation viewName={"MP_PSI_SIMULATION"} title="menuMpPsiSimulation" />
    },
    {
      key: 4103, reduxKey: "MP_PRODUCTION_EXCEPTIONS", title: "menuMpProductionException",
      icon: <LeafIcon />,
      userRoles: ["ROLE_ADMIN", "ROLE_MP_MGR", "ROLE_MP_USER"],
      component: <ProductionExceptions viewName={"MP_PRODUCTION_EXCEPTIONS"} title="menuMpProductionException" />
    },
    {
      key: 4104, reduxKey: "MP_PRODUCTION_EXCEPTIONS_DETAIL", title: "menuMpProductionExceptionsDetail",
      icon: <LeafIcon />,
      userRoles: ["ROLE_ADMIN", "ROLE_MP_MGR", "ROLE_MP_USER"],
      component: <ProductionExceptionsDetail viewName={"MP_PRODUCTION_EXCEPTIONS_DETAIL"} title="menuMpProductionExceptionsDetail" />
    },
    {
      key: 4105, reduxKey: "MP_SCENARIO_COMP", title: "menuMpScenarioComparisonDashboard",
      icon: <LeafIcon />,
      userRoles: ["ROLE_ADMIN", "ROLE_MP_MGR"],
      component: <MpScenarioComDashboard viewName={"MP_SCENARIO_COMP"} title="menuMpScenarioComparisonDashboard" />
    },
    {
      key: 4106, reduxKey: "MP_RESOURCE_GANTT", title: "menuMpResourceGantt",
      icon: <LeafIcon />,
      userRoles: ["ROLE_ADMIN", "ROLE_MP_MGR", "ROLE_MP_USER", "ROLE_GUEST"],
      component: <ResourceGantt viewName={"MP_RESOURCE_GANTT"} title="menuMpResourceGantt" />
    }
  ],
  FP_DASHBOARD: [
    {
      key: 7001, reduxKey: "FP_VERSUS_PERFORMANCE", title: "menuFpVersusPerformance",
      icon: <LeafIcon />,
      userRoles: ["ROLE_ADMIN", "ROLE_FP_MGR", "ROLE_FP_USER", "ROLE_GUEST"],
      component: <FpVersusPerformance viewName={"FP_VERSUS_PERFORMANCE"} title="menuFpVersusPerformance" />
    },
    {
      key: 7002, reduxKey: "FP_INPUT_ORDER_BOARD", title: "menuFpInputOrderBoard",
      icon: <LeafIcon />,
      userRoles: ["ROLE_ADMIN", "ROLE_FP_MGR", "ROLE_FP_USER", "ROLE_GUEST"],
      component: <FpInputOrderBoard viewName={"FP_INPUT_ORDER_BOARD"} title="menuFpInputOrderBoard" />
    },
    {
      key: 7007, reduxKey: "FP_WIP_EOH_OUT_DASHBOARD", title: "menuFpWipEohOutDashboard",
      icon: <LeafIcon />,
      userRoles: ["ROLE_ADMIN", "ROLE_FP_MGR", "ROLE_FP_USER", "ROLE_GUEST"],
      component: <FpWipEohOutDashboard viewName={"FP_WIP_EOH_OUT_DASHBOARD"} title="menuFpWipEohOutDashboard" />
    },
    {
      key: 7008, reduxKey: "FP_SIMULATION_KPI_DASHBOARD", title: "menuFpSimulationKpiDashboard",
      icon: <LeafIcon />,
      userRoles: ["ROLE_ADMIN", "ROLE_FP_MGR", "ROLE_FP_USER", "ROLE_GUEST"],
      component: <FpSimulationKpiDashboard viewName={"FP_SIMULATION_KPI_DASHBOARD"} title="menuFpSimulationKpiDashboard" />
    },
    {
      key: 7009, reduxKey: "FP_PLAN_PROBLEM_DASHBOARD", title: "menuFpPlanProblemDashboard",
      icon: <LeafIcon />,
      userRoles: ["ROLE_ADMIN", "ROLE_FP_MGR", "ROLE_FP_USER", "ROLE_GUEST"],
      component: <FpPlanProblemDashboard viewName={"FP_PLAN_PROBLEM_DASHBOARD"} title="menuFpPlanProblemDashboard" />
    }
  ],
  FP_SIMULATION: [
    {
      key: 7100, reduxKey: "FP_SIMULATION_RUN", title: "menuFpSimulationRun",
      icon: <LeafIcon />,
      userRoles: ["ROLE_ADMIN", "ROLE_FP_MGR", "ROLE_FP_USER", "ROLE_GUEST"],
      component: <FpSimulation viewName={"FP_SIMULATION_RUN"} title="menuFpSimulationRun" />
    },
    {
      key: 7101, reduxKey: "FP_SIMULATION_SCENARIO", title: "menuFpSimulationScenario",
      icon: <LeafIcon />,
      userRoles: ["ROLE_ADMIN", "ROLE_FP_MGR", "ROLE_FP_USER", "ROLE_GUEST"],
      component: <FpSimulationScenario viewName={"FP_SIMULATION_SCENARIO"} title="menuFpSimulationScenario" />
    },
    {
      key: 7102, reduxKey: "FP_SIMULATION_STEP", title: "menuFpSimulationStep",
      icon: <LeafIcon />,
      userRoles: ["ROLE_ADMIN", "ROLE_FP_MGR", "ROLE_FP_USER", "ROLE_GUEST"],
      component: <FpSimulationStep viewName={"FP_SIMULATION_STEP"} title="menuFpSimulationStep" />
    },
    {
      key: 7103, reduxKey: "FP_SIMULATION_COMPARE", title: "menuFpSimulationCompare",
      icon: <LeafIcon />,
      userRoles: ["ROLE_ADMIN", "ROLE_FP_MGR", "ROLE_FP_USER", "ROLE_GUEST"],
      component: <FpSimulationCompare viewName={"FP_SIMULATION_COMPARE"} title="menuFpSimulationCompare" />
    },
    {
      key: 7104, reduxKey: "FP_ADJUST_GRID", title: "menuFpAdjustGrid",
      icon: <LeafIcon />,
      userRoles: ["ROLE_ADMIN", "ROLE_FP_MGR", "ROLE_FP_USER", "ROLE_GUEST"],
      component: <FpAdjustmentGrid viewName={"FP_ADJUST_GRID"} title="menuFpAdjustGrid" />
    },
    {
      key: 7105, reduxKey: "FP_ADJUST_GANTT", title: "menuFpAdjustGantt",
      icon: <LeafIcon />,
      userRoles: ["ROLE_ADMIN", "ROLE_FP_MGR", "ROLE_FP_USER", "ROLE_GUEST"],
      component: <FpAdjustmentGantt viewName={"FP_ADJUST_GANTT"} title="menuFpAdjustGantt" />
    },
  ],
  FP_SCENARIO_PLANNING: [
    { // 스케줄 시나리오 — AI 대메뉴에서 생산계획 밑으로 이관(2026-09-08 사용자 지시).
      //   key 는 AI 범위(6028)에서 FP 범위로 옮겼다. ⚠️ 바꾸면 AiScenarioPlanning 의
      //   MODULE_MENU_KEYS.FP 도 함께 고쳐야 한다(모듈 전환이 그 key 로 탭을 연다).
      //   reduxKey 는 **그대로 둔다** — 화면 상태 캐시와 ScenarioManage.PLANNING_VIEW_KEYS 가 쓴다.
      //   권한(Q-008 종결): lv1 이 ROLE_APP_FP 를 걸고 여기가 ROLE_APP_AI 를 걸어 **둘 다 산
      //   테넌트에서만** 보인다. 엔진을 돌려 버전을 만드는 실행 화면이라 조회 전용은 뺐다.
      key: 7400, reduxKey: "AI_FP_SCENARIO_PLANNING", title: "menuAiFpScenario",
      icon: <LeafIcon />,
      appRoles: ["ROLE_APP_AI"],
      userRoles: ["ROLE_ADMIN", "ROLE_FP_MGR"],
      component: <AiFpScenarioPlanning viewName={"AI_FP_SCENARIO_PLANNING"} />
    },
  ],
  FP_MASTER: [
    {
      key: 7200, reduxKey: "FP_VALIDATION", title: "menuFpValidation",
      icon: <LeafIcon />,
      userRoles: ["ROLE_ADMIN", "ROLE_FP_MGR", "ROLE_FP_USER", "ROLE_GUEST"],
      component: <FpValidation viewName={"FP_VALIDATION"} title="menuFpValidation" />
    },
    {
      key: 7201, reduxKey: "FP_ITEM", title: "menuFpItem",
      icon: <LeafIcon />,
      userRoles: ["ROLE_ADMIN", "ROLE_FP_MGR", "ROLE_FP_USER", "ROLE_GUEST"],
      component: <FpItem viewName={"FP_ITEM"} title="menuFpItem" />
    },
    {
      key: 7202, reduxKey: "FP_ROUTE", title: "menuFpRoute",
      icon: <LeafIcon />,
      userRoles: ["ROLE_ADMIN", "ROLE_FP_MGR", "ROLE_FP_USER", "ROLE_GUEST"],
      component: <FpRoute viewName={"FP_ROUTE"} title="menuFpRoute" />
    },
    {
      key: 7203, reduxKey: "FP_BOM", title: "menuFpBom",
      icon: <LeafIcon />,
      userRoles: ["ROLE_ADMIN", "ROLE_FP_MGR", "ROLE_FP_USER", "ROLE_GUEST"],
      component: <FpBom viewName={"FP_BOM"} title="menuFpBom" />
    },
    {
      key: 7204, reduxKey: "FP_BYPRODUCT", title: "menuFpByproduct",
      icon: <LeafIcon />,
      userRoles: ["ROLE_ADMIN", "ROLE_FP_MGR", "ROLE_FP_USER", "ROLE_GUEST"],
      component: <FpByproduct viewName={"FP_BYPRODUCT"} title="menuFpByproduct" />
    },
    {
      key: 7205, reduxKey: "FP_RESOURCE", title: "menuFpResource",
      icon: <LeafIcon />,
      userRoles: ["ROLE_ADMIN", "ROLE_FP_MGR", "ROLE_FP_USER", "ROLE_GUEST"],
      component: <FpResource viewName={"FP_RESOURCE"} title="menuFpResource" />
    },
    {
      key: 7206, reduxKey: "FP_BOR", title: "menuFpBor",
      icon: <LeafIcon />,
      userRoles: ["ROLE_ADMIN", "ROLE_FP_MGR", "ROLE_FP_USER", "ROLE_GUEST"],
      component: <FpBor viewName={"FP_BOR"} title="menuFpBor" />
    },
    {
      key: 7207, reduxKey: "FP_FLO", title: "menuFpFlo",
      icon: <LeafIcon />,
      userRoles: ["ROLE_ADMIN", "ROLE_FP_MGR", "ROLE_FP_USER", "ROLE_GUEST"],
      component: <FpFlo viewName={"FP_FLO"} title="menuFpFlo" />
    },
    {
      key: 7210, reduxKey: "FP_JOB_CHANGE_TIME", title: "menuFpJobChangeTime",
      icon: <LeafIcon />,
      userRoles: ["ROLE_ADMIN", "ROLE_FP_MGR", "ROLE_FP_USER", "ROLE_GUEST"],
      component: <FpJobChangeTime viewName={"FP_JOB_CHANGE_TIME"} title="menuFpJobChangeTime" />
    },
    {
      key: 7211, reduxKey: "FP_STOCK", title: "menuFpStock",
      icon: <LeafIcon />,
      userRoles: ["ROLE_ADMIN", "ROLE_FP_MGR", "ROLE_FP_USER", "ROLE_GUEST"],
      component: <FpStock viewName={"FP_STOCK"} title="menuFpStock" />
    },
    {
      key: 7212, reduxKey: "FP_WIP", title: "menuFpWip",
      icon: <LeafIcon />,
      userRoles: ["ROLE_ADMIN", "ROLE_FP_MGR", "ROLE_FP_USER", "ROLE_GUEST"],
      component: <FpWip viewName={"FP_WIP"} title="menuFpWip" />
    },
    {
      key: 7213, reduxKey: "FP_ORDER", title: "menuFpOrder",
      icon: <LeafIcon />,
      userRoles: ["ROLE_ADMIN", "ROLE_FP_MGR", "ROLE_FP_USER", "ROLE_GUEST"],
      component: <FpOrder viewName={"FP_ORDER"} title="menuFpOrder" />
    },
    {
      key: 7214, reduxKey: "FP_CONFIGURATION", title: "menuFpConfiguration",
      icon: <LeafIcon />,
      userRoles: ["ROLE_ADMIN", "ROLE_FP_MGR", "ROLE_FP_USER", "ROLE_GUEST"],
      component: <FpConfiguration viewName={"FP_CONFIGURATION"} title="menuFpConfiguration" />
    }
  ],
  FP_ANALYSIS: [
    {
      key: 7300, reduxKey: "FP_PLAN_DETAIL", title: "menuFpPlanDetail",
      icon: <LeafIcon />,
      userRoles: ["ROLE_ADMIN", "ROLE_FP_MGR", "ROLE_FP_USER", "ROLE_GUEST"],
      component: <FpPlanDetail viewName={"FP_PLAN_DETAIL"} title="menuFpPlanDetail" />
    },
    {
      key: 7301, reduxKey: "FP_PLAN_RESULT", title: "menuFpPlanResult",
      icon: <LeafIcon />,
      userRoles: ["ROLE_ADMIN", "ROLE_FP_MGR", "ROLE_FP_USER", "ROLE_GUEST"],
      component: <FpPlanResult viewName={"FP_PLAN_RESULT"} title="menuFpPlanResult" />
    },
    {
      key: 7302, reduxKey: "FP_RESOURCE_UTILIZATION", title: "menuFpResourceUtilization",
      icon: <LeafIcon />,
      userRoles: ["ROLE_ADMIN", "ROLE_FP_MGR", "ROLE_FP_USER", "ROLE_GUEST"],
      component: <FpResourceUtilization viewName={"FP_RESOURCE_UTILIZATION"} title="menuFpResourceUtilization" />
    },
    {
      key: 7303, reduxKey: "FP_RESOURCE_TARGET_UTILIZATION", title: "menuFpResourceTargetUtilization",
      icon: <LeafIcon />,
      userRoles: ["ROLE_ADMIN", "ROLE_FP_MGR", "ROLE_FP_USER", "ROLE_GUEST"],
      component: <FpResourceTargetUtilization viewName={"FP_RESOURCE_TARGET_UTILIZATION"} title="menuFpResourceTargetUtilization" />
    },
    {
      key: 7304, reduxKey: "FP_STOCK_RESULT", title: "menuFpStockResult",
      icon: <LeafIcon />,
      userRoles: ["ROLE_ADMIN", "ROLE_FP_MGR", "ROLE_FP_USER", "ROLE_GUEST"],
      component: <FpStockResult viewName={"FP_STOCK_RESULT"} title="menuFpStockResult" />
    },
    {
      key: 7305, reduxKey: "FP_MATERIAL_PSI", title: "menuFpMaterialPsi",
      icon: <LeafIcon />,
      userRoles: ["ROLE_ADMIN", "ROLE_FP_MGR", "ROLE_FP_USER", "ROLE_GUEST"],
      component: <FpMaterialPsi viewName={"FP_MATERIAL_PSI"} title="menuFpMaterialPsi" />
    },
    {
      key: 7306, reduxKey: "FP_RESOURCE_GANTT", title: "menuFpResourceGantt",
      icon: <LeafIcon />,
      userRoles: ["ROLE_ADMIN", "ROLE_FP_MGR", "ROLE_FP_USER", "ROLE_GUEST"],
      component: <FpResourceGantt viewName={"FP_RESOURCE_GANTT"} title="menuFpResourceGantt" />
    },
    {
      key: 7307, reduxKey: "FP_ORDER_GANTT", title: "menuFpOrderGantt",
      icon: <LeafIcon />,
      userRoles: ["ROLE_ADMIN", "ROLE_FP_MGR", "ROLE_FP_USER", "ROLE_GUEST"],
      component: <FpOrderGantt viewName={"FP_ORDER_GANTT"} title="menuFpOrderGantt" />
    },
    {
      key: 7308, reduxKey: "FP_ORDER_TRACKING", title: "menuFpOrderTracking",
      icon: <LeafIcon />,
      userRoles: ["ROLE_ADMIN", "ROLE_FP_MGR", "ROLE_FP_USER", "ROLE_GUEST"],
      component: <FpOrderTracking viewName={"FP_ORDER_TRACKING"} title="menuFpOrderTracking" />
    },
    {
      key: 7309, reduxKey: "FP_ITEM_LEAD_TIME", title: "menuFpItemLeadTime",
      icon: <LeafIcon />,
      userRoles: ["ROLE_ADMIN", "ROLE_FP_MGR", "ROLE_FP_USER", "ROLE_GUEST"],
      component: <FpItemLeadTime viewName={"FP_ITEM_LEAD_TIME"} title="menuFpItemLeadTime" />
    },
    {
      key: 7310, reduxKey: "FP_CUSTOMER_LEAD_TIME", title: "menuFpCustomerLeadTime",
      icon: <LeafIcon />,
      userRoles: ["ROLE_ADMIN", "ROLE_FP_MGR", "ROLE_FP_USER", "ROLE_GUEST"],
      component: <FpCustomerLeadTime viewName={"FP_CUSTOMER_LEAD_TIME"} title="menuFpCustomerLeadTime" />
    },
    {
      key: 7311, reduxKey: "FP_ITEM_CYCLE_TIME", title: "menuFpItemCycleTime",
      icon: <LeafIcon />,
      userRoles: ["ROLE_ADMIN", "ROLE_FP_MGR", "ROLE_FP_USER", "ROLE_GUEST"],
      component: <FpItemCycleTime viewName={"FP_ITEM_CYCLE_TIME"} title="menuFpItemCycleTime" />
    },
    {
      key: 7312, reduxKey: "FP_JOB_CHANGE_TIME_INFO", title: "menuFpJobChangeTimeInfo",
      icon: <LeafIcon />,
      userRoles: ["ROLE_ADMIN", "ROLE_FP_MGR", "ROLE_FP_USER", "ROLE_GUEST"],
      component: <FpJobChangeTimeInfo viewName={"FP_JOB_CHANGE_TIME_INFO"} title="menuFpJobChangeTimeInfo" />
    },
    {
      key: 7313, reduxKey: "FP_DISPATCH_LIST", title: "menuFpDispatchList",
      icon: <LeafIcon />,
      userRoles: ["ROLE_ADMIN", "ROLE_FP_MGR", "ROLE_FP_USER", "ROLE_GUEST"],
      component: <FpDispatchList viewName={"FP_DISPATCH_LIST"} title="menuFpDispatchList" />
    },
    {
      key: 7314, reduxKey: "FP_DELIVERY_STATUS", title: "menuFpDeliveryStatus",
      icon: <LeafIcon />,
      userRoles: ["ROLE_ADMIN", "ROLE_FP_MGR", "ROLE_FP_USER", "ROLE_GUEST"],
      component: <FpDeliveryStatus viewName={"FP_DELIVERY_STATUS"} title="menuFpDeliveryStatus" />
    },
    {
      key: 7315, reduxKey: "FP_PROD_CUSTOMER", title: "menuFpProdCustomer",
      icon: <LeafIcon />,
      userRoles: ["ROLE_ADMIN", "ROLE_FP_MGR", "ROLE_FP_USER", "ROLE_GUEST"],
      component: <FpProdCustomer viewName={"FP_PROD_CUSTOMER"} title="menuFpProdCustomer" />
    },
    {
      key: 7316, reduxKey: "FP_ITEM_WIP_PROFILE", title: "menuFpItemWipProfile",
      icon: <LeafIcon />,
      userRoles: ["ROLE_ADMIN", "ROLE_FP_MGR", "ROLE_FP_USER", "ROLE_GUEST"],
      component: <FpItemWipProfile viewName={"FP_ITEM_WIP_PROFILE"} title="menuFpItemWipProfile" />
    },
    {
      key: 7317, reduxKey: "FP_RESRC_WIP_PROFILE", title: "menuFpResrcWipProfile",
      icon: <LeafIcon />,
      userRoles: ["ROLE_ADMIN", "ROLE_FP_MGR", "ROLE_FP_USER", "ROLE_GUEST"],
      component: <FpResrcWipProfile viewName={"FP_RESRC_WIP_PROFILE"} title="menuFpResrcWipProfile" />
    },
    {
      key: 7318, reduxKey: "FP_INOUT_STATUS", title: "menuFpInoutStatus",
      icon: <LeafIcon />,
      userRoles: ["ROLE_ADMIN", "ROLE_FP_MGR", "ROLE_FP_USER", "ROLE_GUEST"],
      component: <FpInoutStatus viewName={"FP_INOUT_STATUS"} title="menuFpInoutStatus" />
    },
    {
      key: 7319, reduxKey: "FP_RES_PROD_PLAN", title: "menuFpResProdPlan",
      icon: <LeafIcon />,
      userRoles: ["ROLE_ADMIN", "ROLE_FP_MGR", "ROLE_FP_USER", "ROLE_GUEST"],
      component: <FpResProdPlan viewName={"FP_RES_PROD_PLAN"} title="menuFpResProdPlan" />
    },
    {
      key: 7320, reduxKey: "FP_RESRC_PLAN_RESULT", title: "menuFpResrcPlanResult",
      icon: <LeafIcon />,
      userRoles: ["ROLE_ADMIN", "ROLE_FP_MGR", "ROLE_FP_USER", "ROLE_GUEST"],
      component: <FpResrcPlanResult viewName={"FP_RESRC_PLAN_RESULT"} title="menuFpResrcPlanResult" />
    },
    {
      key: 7321, reduxKey: "FP_PROD_SALES_STOCK_STATUS", title: "menuFpProdSalesStockStatus",
      icon: <LeafIcon />,
      userRoles: ["ROLE_ADMIN", "ROLE_FP_MGR", "ROLE_FP_USER", "ROLE_GUEST"],
      component: <FpProdSalesStockStatus viewName={"FP_PROD_SALES_STOCK_STATUS"} title="menuFpProdSalesStockStatus" />
    },
    {
      key: 7322, reduxKey: "FP_PSI_DETAIL", title: "menuFpPsiDetail",
      icon: <LeafIcon />,
      userRoles: ["ROLE_ADMIN", "ROLE_FP_MGR", "ROLE_FP_USER", "ROLE_GUEST"],
      component: <FpPsiDetail viewName={"FP_PSI_DETAIL"} title="menuFpPsiDetail" />
    },
    {
      key: 7323, reduxKey: "FP_TOOL_AVAILABILITY", title: "menuFpToolAvailability",
      icon: <LeafIcon />,
      userRoles: ["ROLE_ADMIN", "ROLE_FP_MGR", "ROLE_FP_USER", "ROLE_GUEST"],
      component: <FpToolAvailability viewName={"FP_TOOL_AVAILABILITY"} title="menuFpToolAvailability" />
    }
  ],
  MP_ANALYSIS_MONITORING: [
    {
      key: 4200, reduxKey: "MRP_REPORT", title: "menuMpMrpReport",
      icon: <LeafIcon />,
      component: <MrpReport viewName={"MRP_REPORT"} title="menuMpMrpReport" />
    },
    {
      key: 4201, reduxKey: "MRP_ORDER_LIST", title: "menuMpMrpOrderList",
      icon: <LeafIcon />,
      component: <MrpOrderList viewName={"MRP_ORDER_LIST"} title="menuMpMrpOrderList" />
    },
    {
      key: 4202, reduxKey: "RESOURCE_PRODUCTION_PLAN", title: "menuMpResourceProductionPlan",
      icon: <LeafIcon />,
      component: <ResourceProductionPlan viewName={"RESOURCE_PRODUCTION_PLAN"} title="menuMpResourceProductionPlan" />
    },
    {
      key: 4203, reduxKey: "RESOURCE_UTILIZATION", title: "menuMpResourceUtilization",
      icon: <LeafIcon />,
      component: <ResourceUtilization viewName={"RESOURCE_UTILIZATION"} title="menuMpResourceUtilization" />
    },
    {
      key: 4204, reduxKey: "ORDER_TRACKING", title: "menuMpOrderTracking",
      icon: <LeafIcon />,
      component: <OrderTracking viewName={"ORDER_TRACKING"} title="menuMpOrderTracking" />
    },
    {
      key: 4205, reduxKey: "MP_DEMAND_ANALYSIS", title: "menuMpDemandAnalysis",
      icon: <LeafIcon />,
      component: <MpDemandAnalysis viewName={"MP_DEMAND_ANALYSIS"} title="menuMpDemandAnalysis" />
    },
    {
      key: 4206, reduxKey: "INVENTORY_WIP_TRACKING", title: "menuMpInventoryWipTracking",
      icon: <LeafIcon />,
      component: <InventoryWipTracking viewName={"INVENTORY_WIP_TRACKING"} title="menuMpInventoryWipTracking" />
    }
  ],
  BI_REPORT: [],
  AI_ADMIN: [
    { // Agent Chat 트레이스 뷰어 — 답변 근거 SQL·원시 이력·피드백 역추적
      key: 6027, reduxKey: "AI_CHAT_TRACE", title: "menuAiChatTrace",
      icon: <TroubleshootIcon />,
      appRoles: ["ROLE_APP_AI"],
      userRoles: ["ROLE_ADMIN"],
      component: <AiChatTraceViewer viewName={"AI_CHAT_TRACE"} />
    },
    {
      key: 6028, reduxKey: "AI_LLM_USAGE", title: "menuAiLlmUsage",
      icon: <DataUsageIcon />,
      appRoles: ["ROLE_APP_AI"],
      userRoles: ["ROLE_ADMIN"],
      component: <AiLlmUsage viewName={"AI_LLM_USAGE"} />
    },
    { // 테넌트별 용어 사전 — AI 가 알아들을 호칭(별칭)과 뜻(정의)을 표준 위에 덧붙인다
      key: 6030, reduxKey: "AI_TERM_DEFINITION", title: "menuAiTermDefinition",
      icon: <MenuBookIcon />,
      appRoles: ["ROLE_APP_AI"],
      userRoles: ["ROLE_ADMIN"],
      component: <AiTermDefinition viewName={"AI_TERM_DEFINITION"} />
    },
  ],
};

// ── AR Report 동적 메뉴 ──────────────────────────────────────────────────────
let cachedDashboards = [];

const arReportComponent = (dashboardList) => {
  const lang = i18n.language;
  return dashboardList.map((dashboard, idx) => {
    const localizedName = (dashboard.objVal && dashboard.objVal[lang]) || dashboard.reportName;
    return {
      key: 9000 + idx,
      reduxKey: dashboard.quicksightDashboardId,
      title: localizedName,
      skipI18n: true,
      lv2Key: "BI_REPORT",
      icon: <DashboardIcon />,
      appRoles: ["ROLE_APP_BI"],
      component: <CustomReport
        key={dashboard.quicksightDashboardId}
        viewName={localizedName}
        title={localizedName}
        dashboardId={dashboard.quicksightDashboardId}
      />,
    };
  });
};

const getArReportMenu = () => {
  return quickSightService.getDashboards()
    .then((response) => {
      cachedDashboards = response.data;
      lv3MenuList.BI_REPORT = arReportComponent(cachedDashboards);
    })
    .catch((error) => {
      console.error("[TabMenuList] Failed to load AR Report dashboards:", error);
    });
};

const rebuildArReportMenu = () => {
  if (cachedDashboards.length > 0) {
    lv3MenuList.BI_REPORT = arReportComponent(cachedDashboards);
  }
};

// reduxKey(=viewName) → 번역된 메뉴 제목. 홈 "고정한 대시보드" 카드 라벨 등에서 사용.
//   모든 lv3 그룹(DASHBOARD/BI_REPORT/…)의 leaf 를 훑어 매칭하고, 제목은 번역 키이므로 i18n.t 로 변환.
const getLocalizedTitle = (reduxKey) => {
  for (const group of Object.values(lv3MenuList)) {
    if (!Array.isArray(group)) continue;
    const menu = group.find((m) => m?.reduxKey === reduxKey);
    if (menu?.title) return i18n.t(menu.title);
  }
  return null;
};

const getAllLv1MenuCdList = () => {
  return Object.keys(lv1MenuList);
};

const getLv1MenuInfo = (lv1MenuCd) => {
  return lv1MenuList[lv1MenuCd];
};

const getLv2MenuList = (lv1MenuCd) => {
  return lv2MenuList[lv1MenuCd];
};

const getLv3MenuList = (lv2MenuCd) => {
  return lv3MenuList[lv2MenuCd];
};

const makeSideMenuList = () => {
  const mainMenuCodeList = getAllLv1MenuCdList();
  const allMenuList = [];
  for (const mainMenuCode in mainMenuCodeList) {
    let newLv2Menu = null;
    let lv2MenuArray = [];
    const subMenu = [];
    const checkSideMenu = lv1MenuList[mainMenuCodeList[mainMenuCode]].sideBarMenu;
    const singleMenu = lv1MenuList[mainMenuCodeList[mainMenuCode]].singleMenu;
    const lv2Menu = getLv2MenuList(mainMenuCodeList[mainMenuCode]);
    const lv3Menu = getLv3MenuList(mainMenuCodeList[mainMenuCode]);

    if (!lv2Menu) {
      subMenu.push(false);
      lv2MenuArray = getLv3MenuList(mainMenuCodeList[mainMenuCode]);
    } else {
      for (const lv2MenuCode in lv2Menu) {
        newLv2Menu = {
          ...lv2Menu[lv2MenuCode],
          menuTitle: lv2Menu[lv2MenuCode].menuTitle,
          lv3Menu: getLv3MenuList(lv2Menu[lv2MenuCode].menuCd),
        };
        subMenu.push(true);
        lv2MenuArray.push(newLv2Menu);
      }

      if (lv3Menu && lv3Menu.length > 0) {
        for (const lv3MenuCode in lv3Menu) {
          lv2MenuArray.push(lv3Menu[lv3MenuCode]);
          subMenu.push(false);
        }
      }
    }

    allMenuList.push({
      ...getLv1MenuInfo(mainMenuCodeList[mainMenuCode]),
      lv2Menu: lv2MenuArray,
      lv1MenuCd: mainMenuCodeList[mainMenuCode],
      sideMenu: checkSideMenu,
      singleMenu,
      subMenu
    });
  }

  return allMenuList;
};

/*
  미출시 화면(leaf 또는 그 lv1 에 unreleased: true)인가.
  hide 와 다르다 — hide 는 사이드바에서만 빼고 링크로는 열리게 두는 표시다(AUDIT_TRAIL_DETAIL 처럼
  링크 전용 화면이 쓴다). unreleased 는 링크·저장된 탭 복원·챗 이동까지 전부 막는다.
*/
const isUnreleasedMenu = (keyOrReduxKey) => {
  if (keyOrReduxKey == null) return false;
  for (const lv2Key in lv3MenuList) {
    const leaf = lv3MenuList[lv2Key].find(m => m.key === keyOrReduxKey || m.reduxKey === keyOrReduxKey);
    if (!leaf) continue;
    if (leaf.unreleased) return true;
    // lv2Key 가 lv1 코드 자체면 lv1 직속 leaf, 아니면 lv2 그룹을 거쳐 lv1 을 찾는다
    const lv1Key = lv1MenuList[lv2Key] ? lv2Key
      : Object.keys(lv2MenuList).find(k => lv2MenuList[k].some(g => g.menuCd === lv2Key));
    return !!lv1MenuList[lv1Key]?.unreleased;
  }
  return false;
};

const findLv3Menu = (lv3Key, lv2keyInclude = false) => {
  let foundMenu = null;
  const menuPath = [];
  for (const lv2Key in lv3MenuList) {
    foundMenu = lv3MenuList[lv2Key].find(element => element.key === lv3Key || element.reduxKey === lv3Key);
    if (foundMenu) {
      if (lv2keyInclude) foundMenu.lv2Key = lv2Key;
      const singleMenu = foundMenu.singleMenu ?? false;
      menuPath.push({ menuCd: foundMenu.key, menuTitle: foundMenu.title, singleMenu, skipI18n: foundMenu.skipI18n ?? false, reduxKey: foundMenu.reduxKey });
      for (const lv1Key in lv2MenuList) {
        const lv2Menu = lv2MenuList[lv1Key].find(element => element.menuCd === lv2Key);
        if (lv2Menu) {
          menuPath.push({
            menuCd: lv2Menu.menuCd,
            menuTitle: lv2Menu.menuTitle
          }, {
            menuCd: lv1Key,
            menuTitle: lv1MenuList[lv1Key].title
          });
          break;
        }
      }
      break;
    }
  }

  if (foundMenu) {
    foundMenu.menuPath = menuPath ? menuPath.reverse() : menuPath;
  }

  return foundMenu;
};


// 이름(현재 언어 메뉴 제목 또는 번역 키)으로 lv3 메뉴를 찾는다 — Agent Chat 화면 이동용.
//   translate: i18n t 함수 (제목이 번역 키이므로 필요). 공백·중점 무시, 정확 일치 우선 → 부분 일치.
const findLv3MenuByName = (text, translate) => {
  const norm = (v) => String(v ?? "").replace(/[\s·・.]/g, "").toLowerCase();
  const target = norm(text);
  if (!target) return null;
  let partial = null;
  for (const lv2Key in lv3MenuList) {
    for (const m of lv3MenuList[lv2Key]) {
      const label = m.skipI18n ? m.title : (translate ? translate(m.title) : m.title);
      const name = norm(label);
      if (!name) continue;
      if (name === target) return m;
      if (!partial && name.length >= 2 && (name.includes(target) || target.includes(name))) partial = m;
    }
  }
  return partial;
};

const TabMenuList = {
  MENU_GROUP,
  makeSideMenuList,
  isUnreleasedMenu,
  getAllLv1MenuCdList,
  getLv1MenuInfo,
  getLv2MenuList,
  getLv3MenuList,
  findLv3Menu,
  findLv3MenuByName,
  getArReportMenu,
  rebuildArReportMenu,
  getLocalizedTitle,
};

export default TabMenuList;
